/* Table of Contents
==================================================

    #Slate Default
    #Custom Velstar

==================================================
*/

/* ==========================================================================
#Slate Default
========================================================================== */

window.slate = window.slate || {};
window.theme = window.theme || {};

/*================ Settings ================*/
//Create Vars that match SCSS breakpoints, defined in variables.scss.liquid file.
var screenSM = 576,
	screenMD = 768,
	screenLG = 992,
    screenXL = 1200;
    
var slickPrevArrow = "<button class='slick-prev slick-arrow' aria-label='Previous' type='button'><svg width='16px' height='16px' viewBox='0 0 16 16' version='1.1' xmlns='http://www.w3.org/2000/svg'><g id='Arrow_left' stroke='none' stroke-width='1' fill='none' fill-rule='evenodd'><polygon id='Triangle-Copy' fill='#333333' transform='translate(8.000000, 8.000000) scale(-1, 1) rotate(450.000000) translate(-8.000000, -8.000000)' points='8 4 12 12 4 12'></polygon></g></svg></button>",
    slickNextArrow = "<button class='slick-next slick-arrow' aria-label='Next' type='button'><svg width='16px' height='16px' viewBox='0 0 16 16' version='1.1' xmlns='http://www.w3.org/2000/svg'><g id='Arrow_right' stroke='none' stroke-width='1' fill='none' fill-rule='evenodd'><polygon id='Triangle-Copy' fill='#333333' transform='translate(8.000000, 8.000000) scale(-1, 1) rotate(-90.000000) translate(-8.000000, -8.000000)' points='8 4 12 12 4 12'></polygon></g></svg></button>";

//if no image available, load the SVG placeholder image. Generate by the liquid tag {{ 'product-1' | placeholder_svg_tag: 'svg-placeholder' }}
var svgPlaceholder = '<svg class="svg-placeholder" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 525.5 525.5"><path d="M375.5 345.2c0-.1 0-.1 0 0 0-.1 0-.1 0 0-1.1-2.9-2.3-5.5-3.4-7.8-1.4-4.7-2.4-13.8-.5-19.8 3.4-10.6 3.6-40.6 1.2-54.5-2.3-14-12.3-29.8-18.5-36.9-5.3-6.2-12.8-14.9-15.4-17.9 8.6-5.6 13.3-13.3 14-23 0-.3 0-.6.1-.8.4-4.1-.6-9.9-3.9-13.5-2.1-2.3-4.8-3.5-8-3.5h-54.9c-.8-7.1-3-13-5.2-17.5-6.8-13.9-12.5-16.5-21.2-16.5h-.7c-8.7 0-14.4 2.5-21.2 16.5-2.2 4.5-4.4 10.4-5.2 17.5h-48.5c-3.2 0-5.9 1.2-8 3.5-3.2 3.6-4.3 9.3-3.9 13.5 0 .2 0 .5.1.8.7 9.8 5.4 17.4 14 23-2.6 3.1-10.1 11.7-15.4 17.9-6.1 7.2-16.1 22.9-18.5 36.9-2.2 13.3-1.2 47.4 1 54.9 1.1 3.8 1.4 14.5-.2 19.4-1.2 2.4-2.3 5-3.4 7.9-4.4 11.6-6.2 26.3-5 32.6 1.8 9.9 16.5 14.4 29.4 14.4h176.8c12.9 0 27.6-4.5 29.4-14.4 1.2-6.5-.5-21.1-5-32.7zm-97.7-178c.3-3.2.8-10.6-.2-18 2.4 4.3 5 10.5 5.9 18h-5.7zm-36.3-17.9c-1 7.4-.5 14.8-.2 18h-5.7c.9-7.5 3.5-13.7 5.9-18zm4.5-6.9c0-.1.1-.2.1-.4 4.4-5.3 8.4-5.8 13.1-5.8h.7c4.7 0 8.7.6 13.1 5.8 0 .1 0 .2.1.4 3.2 8.9 2.2 21.2 1.8 25h-30.7c-.4-3.8-1.3-16.1 1.8-25zm-70.7 42.5c0-.3 0-.6-.1-.9-.3-3.4.5-8.4 3.1-11.3 1-1.1 2.1-1.7 3.4-2.1l-.6.6c-2.8 3.1-3.7 8.1-3.3 11.6 0 .2 0 .5.1.8.3 3.5.9 11.7 10.6 18.8.3.2.8.2 1-.2.2-.3.2-.8-.2-1-9.2-6.7-9.8-14.4-10-17.7 0-.3 0-.6-.1-.8-.3-3.2.5-7.7 3-10.5.8-.8 1.7-1.5 2.6-1.9h155.7c1 .4 1.9 1.1 2.6 1.9 2.5 2.8 3.3 7.3 3 10.5 0 .2 0 .5-.1.8-.3 3.6-1 13.1-13.8 20.1-.3.2-.5.6-.3 1 .1.2.4.4.6.4.1 0 .2 0 .3-.1 13.5-7.5 14.3-17.5 14.6-21.3 0-.3 0-.5.1-.8.4-3.5-.5-8.5-3.3-11.6l-.6-.6c1.3.4 2.5 1.1 3.4 2.1 2.6 2.9 3.5 7.9 3.1 11.3 0 .3 0 .6-.1.9-1.5 20.9-23.6 31.4-65.5 31.4h-43.8c-41.8 0-63.9-10.5-65.4-31.4zm91 89.1h-7c0-1.5 0-3-.1-4.2-.2-12.5-2.2-31.1-2.7-35.1h3.6c.8 0 1.4-.6 1.4-1.4v-14.1h2.4v14.1c0 .8.6 1.4 1.4 1.4h3.7c-.4 3.9-2.4 22.6-2.7 35.1v4.2zm65.3 11.9h-16.8c-.4 0-.7.3-.7.7 0 .4.3.7.7.7h16.8v2.8h-62.2c0-.9-.1-1.9-.1-2.8h33.9c.4 0 .7-.3.7-.7 0-.4-.3-.7-.7-.7h-33.9c-.1-3.2-.1-6.3-.1-9h62.5v9zm-12.5 24.4h-6.3l.2-1.6h5.9l.2 1.6zm-5.8-4.5l1.6-12.3h2l1.6 12.3h-5.2zm-57-19.9h-62.4v-9h62.5c0 2.7 0 5.8-.1 9zm-62.4 1.4h62.4c0 .9-.1 1.8-.1 2.8H194v-2.8zm65.2 0h7.3c0 .9.1 1.8.1 2.8H259c.1-.9.1-1.8.1-2.8zm7.2-1.4h-7.2c.1-3.2.1-6.3.1-9h7c0 2.7 0 5.8.1 9zm-7.7-66.7v6.8h-9v-6.8h9zm-8.9 8.3h9v.7h-9v-.7zm0 2.1h9v2.3h-9v-2.3zm26-1.4h-9v-.7h9v.7zm-9 3.7v-2.3h9v2.3h-9zm9-5.9h-9v-6.8h9v6.8zm-119.3 91.1c-2.1-7.1-3-40.9-.9-53.6 2.2-13.5 11.9-28.6 17.8-35.6 5.6-6.5 13.5-15.7 15.7-18.3 11.4 6.4 28.7 9.6 51.8 9.6h6v14.1c0 .8.6 1.4 1.4 1.4h5.4c.3 3.1 2.4 22.4 2.7 35.1 0 1.2.1 2.6.1 4.2h-63.9c-.8 0-1.4.6-1.4 1.4v16.1c0 .8.6 1.4 1.4 1.4H256c-.8 11.8-2.8 24.7-8 33.3-2.6 4.4-4.9 8.5-6.9 12.2-.4.7-.1 1.6.6 1.9.2.1.4.2.6.2.5 0 1-.3 1.3-.8 1.9-3.7 4.2-7.7 6.8-12.1 5.4-9.1 7.6-22.5 8.4-34.7h7.8c.7 11.2 2.6 23.5 7.1 32.4.2.5.8.8 1.3.8.2 0 .4 0 .6-.2.7-.4 1-1.2.6-1.9-4.3-8.5-6.1-20.3-6.8-31.1H312l-2.4 18.6c-.1.4.1.8.3 1.1.3.3.7.5 1.1.5h9.6c.4 0 .8-.2 1.1-.5.3-.3.4-.7.3-1.1l-2.4-18.6H333c.8 0 1.4-.6 1.4-1.4v-16.1c0-.8-.6-1.4-1.4-1.4h-63.9c0-1.5 0-2.9.1-4.2.2-12.7 2.3-32 2.7-35.1h5.2c.8 0 1.4-.6 1.4-1.4v-14.1h6.2c23.1 0 40.4-3.2 51.8-9.6 2.3 2.6 10.1 11.8 15.7 18.3 5.9 6.9 15.6 22.1 17.8 35.6 2.2 13.4 2 43.2-1.1 53.1-1.2 3.9-1.4 8.7-1 13-1.7-2.8-2.9-4.4-3-4.6-.2-.3-.6-.5-.9-.6h-.5c-.2 0-.4.1-.5.2-.6.5-.8 1.4-.3 2 0 0 .2.3.5.8 1.4 2.1 5.6 8.4 8.9 16.7h-42.9v-43.8c0-.8-.6-1.4-1.4-1.4s-1.4.6-1.4 1.4v44.9c0 .1-.1.2-.1.3 0 .1 0 .2.1.3v9c-1.1 2-3.9 3.7-10.5 3.7h-7.5c-.4 0-.7.3-.7.7 0 .4.3.7.7.7h7.5c5 0 8.5-.9 10.5-2.8-.1 3.1-1.5 6.5-10.5 6.5H210.4c-9 0-10.5-3.4-10.5-6.5 2 1.9 5.5 2.8 10.5 2.8h67.4c.4 0 .7-.3.7-.7 0-.4-.3-.7-.7-.7h-67.4c-6.7 0-9.4-1.7-10.5-3.7v-54.5c0-.8-.6-1.4-1.4-1.4s-1.4.6-1.4 1.4v43.8h-43.6c4.2-10.2 9.4-17.4 9.5-17.5.5-.6.3-1.5-.3-2s-1.5-.3-2 .3c-.1.2-1.4 2-3.2 5 .1-4.9-.4-10.2-1.1-12.8zm221.4 60.2c-1.5 8.3-14.9 12-26.6 12H174.4c-11.8 0-25.1-3.8-26.6-12-1-5.7.6-19.3 4.6-30.2H197v9.8c0 6.4 4.5 9.7 13.4 9.7h105.4c8.9 0 13.4-3.3 13.4-9.7v-9.8h44c4 10.9 5.6 24.5 4.6 30.2z"></path><path d="M286.1 359.3c0 .4.3.7.7.7h14.7c.4 0 .7-.3.7-.7 0-.4-.3-.7-.7-.7h-14.7c-.3 0-.7.3-.7.7zm5.3-145.6c13.5-.5 24.7-2.3 33.5-5.3.4-.1.6-.5.4-.9-.1-.4-.5-.6-.9-.4-8.6 3-19.7 4.7-33 5.2-.4 0-.7.3-.7.7 0 .4.3.7.7.7zm-11.3.1c.4 0 .7-.3.7-.7 0-.4-.3-.7-.7-.7H242c-19.9 0-35.3-2.5-45.9-7.4-.4-.2-.8 0-.9.3-.2.4 0 .8.3.9 10.8 5 26.4 7.5 46.5 7.5h38.1zm-7.2 116.9c.4.1.9.1 1.4.1 1.7 0 3.4-.7 4.7-1.9 1.4-1.4 1.9-3.2 1.5-5-.2-.8-.9-1.2-1.7-1.1-.8.2-1.2.9-1.1 1.7.3 1.2-.4 2-.7 2.4-.9.9-2.2 1.3-3.4 1-.8-.2-1.5.3-1.7 1.1s.2 1.5 1 1.7z"></path><path d="M275.5 331.6c-.8 0-1.4.6-1.5 1.4 0 .8.6 1.4 1.4 1.5h.3c3.6 0 7-2.8 7.7-6.3.2-.8-.4-1.5-1.1-1.7-.8-.2-1.5.4-1.7 1.1-.4 2.3-2.8 4.2-5.1 4zm5.4 1.6c-.6.5-.6 1.4-.1 2 1.1 1.3 2.5 2.2 4.2 2.8.2.1.3.1.5.1.6 0 1.1-.3 1.3-.9.3-.7-.1-1.6-.8-1.8-1.2-.5-2.2-1.2-3-2.1-.6-.6-1.5-.6-2.1-.1zm-38.2 12.7c.5 0 .9 0 1.4-.1.8-.2 1.3-.9 1.1-1.7-.2-.8-.9-1.3-1.7-1.1-1.2.3-2.5-.1-3.4-1-.4-.4-1-1.2-.8-2.4.2-.8-.3-1.5-1.1-1.7-.8-.2-1.5.3-1.7 1.1-.4 1.8.1 3.7 1.5 5 1.2 1.2 2.9 1.9 4.7 1.9z"></path><path d="M241.2 349.6h.3c.8 0 1.4-.7 1.4-1.5s-.7-1.4-1.5-1.4c-2.3.1-4.6-1.7-5.1-4-.2-.8-.9-1.3-1.7-1.1-.8.2-1.3.9-1.1 1.7.7 3.5 4.1 6.3 7.7 6.3zm-9.7 3.6c.2 0 .3 0 .5-.1 1.6-.6 3-1.6 4.2-2.8.5-.6.5-1.5-.1-2s-1.5-.5-2 .1c-.8.9-1.8 1.6-3 2.1-.7.3-1.1 1.1-.8 1.8 0 .6.6.9 1.2.9z"></path></svg>';
//BG: The below function is used by both the Recently Viewed and Related Products. When looping through the products, we use the below as a template.
function outputProduct(data, outputLocation) {
    var imageRatioClass = $(outputLocation).attr('data-image-ratio');
  
    var productHTML = "";
        productHTML += '<div class="col-6 col-md-13 featured-product mb-3">';
            productHTML += '<div class="inner-featured-product">';
            productHTML += '<div class="product-image">';
                productHTML += '<a href="/products/'+data.handle+'" title="'+data.title+'" class="'+imageRatioClass+'">';
                    if (data.featured_image != null) {
                        productHTML += '<img data-sizes="auto" data-src="'+slate.Image.getSizedImageUrl(data.featured_image,'400x')+'" data-srcset="'+slate.Image.getSizedImageUrl(data.featured_image,'400x')+' 400w, '+slate.Image.getSizedImageUrl(data.featured_image,'540x')+' 540w, '+slate.Image.getSizedImageUrl(data.featured_image,'720x')+' 720w, '+slate.Image.getSizedImageUrl(data.featured_image,'900x')+' 900w" alt="'+data.title+'" class="img-fluid lazyload" />';
                    } else {
                        productHTML += svgPlaceholder;
                    }
                productHTML += '</a>';
            productHTML += '</div>';
            productHTML += '<div class="product-details">';
                productHTML += '<a href="/products/'+data.handle+'" title="'+data.title+'">';
                    productHTML += '<h3 class="product-title">'+data.title+'</h3>';
                productHTML += '</a>';
            productHTML += '</div>';
            productHTML += '</div>';
        productHTML += '</div>';
  
    $(outputLocation).find('.row.featured-products-slick').prepend(productHTML); 
}

/*
BG: persistentCheck: The idea being to constantly check (or persistently check) if the target exists, if it does, pass in an additional function that will trigger once condition is true. If condition is never true, have a timeoutTime to stop checking. 
*/
function persistentCheck(target,targetValue,paramFunction,paramTarget,timeoutTime) {
    //console.log('persistentCheckFunction');
    var checkExist = setInterval(function() {
        //console.log('Persistently checking for: '+target);
    //keep checking to see if condition is true 

    if ($(target).length > targetValue) {
            //console.log('condition is true, will no longer check.');
            //check paramFunction is actually a function
            if (typeof paramFunction == "function") {
                paramFunction(paramTarget); 
            }
            //clear interval
            clearInterval(checkExist);
        }
    }, 100); // check every 100ms
    
    setTimeout(function(){
        //console.log('couldn\'t find target or condition wasn\'t true');
        clearInterval(checkExist);
    }, timeoutTime);
}

/**
 * BG: The idea is to use the data-slick to define additional options. We only define the arrow styling below for consisteny.
 * if the ShopifySectionID is present, the function is being called after editing options within the theme customiser. The intention is to pass over the unique section id to destory and re-enable the slick. Slides could have been added or removed, and destorying it and re-enabling will capture this change. 
 */
 function inlineSlick(shopifySectionID) {

    //console.log('inlineSlickFire');

    if (shopifySectionID) {

        $('#shopify-section-'+shopifySectionID+' .inline-slick').slick({
            prevArrow: slickPrevArrow,
            nextArrow: slickNextArrow
        });
        
    } else {

        $('.inline-slick').slick({
            prevArrow: slickPrevArrow,
            nextArrow: slickNextArrow
        });
    }
}

inlineSlick();

//BG: Callback when theme customizer section option are changed.
//https://shopify.dev/tutorials/develop-theme-sections-integration-with-theme-editor
$(document).on('shopify:section:load', function(event){
    inlineSlick(event.detail.sectionId);
});

//on window resize
$(window).on('resize orientationChange', function(event) {

    //if slick has previously been destroy via inline attr, we have to reinit with JS.
    //Here we are looping through each inline-slick that doesn't have the class slick-initialzed. 
    $('.inline-slick:not(.slick-initialized)').each(function(){
        $(this).slick({
            prevArrow: slickPrevArrow,
            nextArrow: slickNextArrow
        });
    })

});

function mobileAnchoring() {
    if ($(window).width() < screenLG) {
        $(function () {
            var pathName = document.location.pathname;
            window.onbeforeunload = function () {
                var scrollPosition = $(document).scrollTop();
                sessionStorage.setItem("scrollPosition_" + pathName, scrollPosition.toString());
            }
            if (sessionStorage["scrollPosition_" + pathName]) {
                $(document).scrollTop(sessionStorage.getItem("scrollPosition_" + pathName));
            }
        });
    }
}

mobileAnchoring();

/*================ Slate ================*/
/**
 * A11y Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help make your theme more accessible
 * to users with visual impairments.
 *
 *
 * @namespace a11y
 */

slate.a11y = {

  /**
   * For use when focus shifts to a container rather than a link
   * eg for In-page links, after scroll, focus shifts to content area so that
   * next `tab` is where user expects if focusing a link, just $link.focus();
   *
   * @param {JQuery} $element - The element to be acted upon
   */
  pageLinkFocus: function($element) {
    var focusClass = 'js-focus-hidden';

    $element.first()
      .attr('tabIndex', '-1')
      .focus()
      .addClass(focusClass)
      .one('blur', callback);

    function callback() {
      $element.first()
        .removeClass(focusClass)
        .removeAttr('tabindex');
    }
  },

  /**
   * If there's a hash in the url, focus the appropriate element
   */
  focusHash: function() {
    var hash = window.location.hash;

    // is there a hash in the url? is it an element on the page?
    if (hash && document.getElementById(hash.slice(1))) {
      this.pageLinkFocus($(hash));
    }
  },

  /**
   * When an in-page (url w/hash) link is clicked, focus the appropriate element
   */
  bindInPageLinks: function() {
    $('a[href*=#]').on('click', function(evt) {
      this.pageLinkFocus($(evt.currentTarget.hash));
    }.bind(this));
  },

  /**
   * Traps the focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {jQuery} options.$container - Container to trap focus within
   * @param {jQuery} options.$elementToFocus - Element to be focused when focus leaves container
   * @param {string} options.namespace - Namespace used for new focus event handler
   */
  trapFocus: function(options) {
    var eventName = options.namespace
      ? 'focusin.' + options.namespace
      : 'focusin';

    if (!options.$elementToFocus) {
      options.$elementToFocus = options.$container;
    }

    options.$container.attr('tabindex', '-1');
    options.$elementToFocus.focus();

    $(document).on(eventName, function(evt) {
      if (options.$container[0] !== evt.target && !options.$container.has(evt.target).length) {
        options.$container.focus();
      }
    });
  },

  /**
   * Removes the trap of focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {jQuery} options.$container - Container to trap focus within
   * @param {string} options.namespace - Namespace used for new focus event handler
   */
  removeTrapFocus: function(options) {
    var eventName = options.namespace
      ? 'focusin.' + options.namespace
      : 'focusin';

    if (options.$container && options.$container.length) {
      options.$container.removeAttr('tabindex');
    }

    $(document).off(eventName);
  }
};

/**
 * Cart Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Cart template.
 *
 * @namespace cart
 */

slate.cart = {
  
  /**
   * Browser cookies are required to use the cart. This function checks if
   * cookies are enabled in the browser.
   */
  cookiesEnabled: function() {
    var cookieEnabled = navigator.cookieEnabled;

    if (!cookieEnabled){
      document.cookie = 'testcookie';
      cookieEnabled = (document.cookie.indexOf('testcookie') !== -1);
    }
    return cookieEnabled;
  }
};

/**
 * Utility helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions for dealing with arrays and objects
 *
 * @namespace utils
 */

slate.utils = {

  /**
   * Return an object from an array of objects that matches the provided key and value
   *
   * @param {array} array - Array of objects
   * @param {string} key - Key to match the value against
   * @param {string} value - Value to get match of
   */
  findInstance: function(array, key, value) {
    for (var i = 0; i < array.length; i++) {
      if (array[i][key] === value) {
        return array[i];
      }
    }
  },

  /**
   * Remove an object from an array of objects by matching the provided key and value
   *
   * @param {array} array - Array of objects
   * @param {string} key - Key to match the value against
   * @param {string} value - Value to get match of
   */
  removeInstance: function(array, key, value) {
    var i = array.length;
    while(i--) {
      if (array[i][key] === value) {
        array.splice(i, 1);
        break;
      }
    }

    return array;
  },

  /**
   * _.compact from lodash
   * Remove empty/false items from array
   * Source: https://github.com/lodash/lodash/blob/master/compact.js
   *
   * @param {array} array
   */
  compact: function(array) {
    var index = -1;
    var length = array == null ? 0 : array.length;
    var resIndex = 0;
    var result = [];

    while (++index < length) {
      var value = array[index];
      if (value) {
        result[resIndex++] = value;
      }
    }
    return result;
  },

  /**
   * _.defaultTo from lodash
   * Checks `value` to determine whether a default value should be returned in
   * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
   * or `undefined`.
   * Source: https://github.com/lodash/lodash/blob/master/defaultTo.js
   *
   * @param {*} value - Value to check
   * @param {*} defaultValue - Default value
   * @returns {*} - Returns the resolved value
   */
  defaultTo: function(value, defaultValue) {
    return (value == null || value !== value) ? defaultValue : value
  }
};

/**
 * Rich Text Editor
 * -----------------------------------------------------------------------------
 * Wrap iframes and tables in div tags to force responsive/scrollable layout.
 *
 * @namespace rte
 */

slate.rte = {
  /**
   * Wrap tables in a container div to make them scrollable when needed
   *
   * @param {object} options - Options to be used
   * @param {jquery} options.$tables - jquery object(s) of the table(s) to wrap
   * @param {string} options.tableWrapperClass - table wrapper class name
   */
  wrapTable: function(options) {
    var tableWrapperClass = typeof options.tableWrapperClass === "undefined" ? '' : options.tableWrapperClass;

    options.$tables.wrap('<div class="' + tableWrapperClass + '"></div>');
  },

  /**
   * Wrap iframes in a container div to make them responsive
   *
   * @param {object} options - Options to be used
   * @param {jquery} options.$iframes - jquery object(s) of the iframe(s) to wrap
   * @param {string} options.iframeWrapperClass - class name used on the wrapping div
   */
  wrapIframe: function(options) {
    var iframeWrapperClass = typeof options.iframeWrapperClass === "undefined" ? '' : options.iframeWrapperClass;

    options.$iframes.each(function() {
      // Add wrapper to make video responsive
      $(this).wrap('<div class="' + iframeWrapperClass + '"></div>');
      
      // Re-set the src attribute on each iframe after page load
      // for Chrome's "incorrect iFrame content on 'back'" bug.
      // https://code.google.com/p/chromium/issues/detail?id=395791
      // Need to specifically target video and admin bar
      this.src = this.src;
    });
  }
};

slate.Sections = function Sections() {
  this.constructors = {};
  this.instances = [];

  $(document)
    .on('shopify:section:load', this._onSectionLoad.bind(this))
    .on('shopify:section:unload', this._onSectionUnload.bind(this))
    .on('shopify:section:select', this._onSelect.bind(this))
    .on('shopify:section:deselect', this._onDeselect.bind(this))
    .on('shopify:section:reorder', this._onReorder.bind(this))
    .on('shopify:block:select', this._onBlockSelect.bind(this))
    .on('shopify:block:deselect', this._onBlockDeselect.bind(this));
};

slate.Sections.prototype = $.extend({}, slate.Sections.prototype, {
  _createInstance: function(container, constructor) {
    var $container = $(container);
    var id = $container.attr('data-section-id');
    var type = $container.attr('data-section-type');

    constructor = constructor || this.constructors[type];

    if (typeof constructor === 'undefined') {
      return;
    }

    var instance = $.extend(new constructor(container), {
      id: id,
      type: type,
      container: container
    });

    this.instances.push(instance);
  },

  _onSectionLoad: function(evt) {
    var container = $('[data-section-id]', evt.target)[0];
    if (container) {
      this._createInstance(container);
    }
  },

  _onSectionUnload: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (!instance) {
      return;
    }

    if (typeof instance.onUnload === 'function') {
      instance.onUnload(evt);
    }

    this.instances = slate.utils.removeInstance(this.instances, 'id', evt.detail.sectionId);
  },

  _onSelect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onSelect === 'function') {
      instance.onSelect(evt);
    }
  },

  _onDeselect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onDeselect === 'function') {
      instance.onDeselect(evt);
    }
  },

  _onReorder: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onReorder === 'function') {
      instance.onReorder(evt);
    }
  },

  _onBlockSelect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onBlockSelect === 'function') {
      instance.onBlockSelect(evt);
    }
  },

  _onBlockDeselect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onBlockDeselect === 'function') {
      instance.onBlockDeselect(evt);
    }
  },

  register: function(type, constructor) {
    this.constructors[type] = constructor;

    $('[data-section-type=' + type + ']').each(function(index, container) {
      this._createInstance(container, constructor);
    }.bind(this));
  }
});

/**
 * Currency Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help with currency formatting
 *
 * Current contents
 * - formatMoney - Takes an amount in cents and returns it as a formatted dollar value.
 *
 */

slate.Currency = (function() {
  var moneyFormat = '${{amount}}';

  /**
   * Format money values based on your shop currency settings
   * @param  {Number|string} cents - value in cents or dollar amount e.g. 300 cents
   * or 3.00 dollars
   * @param  {String} format - shop money_format setting
   * @return {String} value - formatted value
   */
  function formatMoney(cents, format) {
    if (typeof cents === 'string') {
      cents = cents.replace('.', '');
    }
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = (format || moneyFormat);

    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = slate.utils.defaultTo(precision, 2);
      thousands = slate.utils.defaultTo(thousands, ',');
      decimal = slate.utils.defaultTo(decimal, '.');

      if (isNaN(number) || number == null) {
        return 0;
      }

      number = (number / 100.0).toFixed(precision);

      var parts = number.split('.');
      var dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var centsAmount = parts[1] ? (decimal + parts[1]) : '';

      return dollarsAmount + centsAmount;
    }

    switch (formatString.match(placeholderRegex)[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_space_separator':
        value = formatWithDelimiters(cents, 2, ' ', '.');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, ',', '.');
        break;
      case 'amount_no_decimals_with_space_separator':
        value = formatWithDelimiters(cents, 0, ' ');
        break;
    }

    return formatString.replace(placeholderRegex, value);
  }

  return {
    formatMoney: formatMoney
  };
})();

/**
 * Image Helper Functions
 * -----------------------------------------------------------------------------
 * A collection of functions that help with basic image operations.
 *
 */

slate.Image = (function() {

  /**
   * Preloads an image in memory and uses the browsers cache to store it until needed.
   *
   * @param {Array} images - A list of image urls
   * @param {String} size - A shopify image size attribute
   */

  function preload(images, size) {
    if (typeof images === 'string') {
      images = [images];
    }

    for (var i = 0; i < images.length; i++) {
      var image = images[i];
      this.loadImage(this.getSizedImageUrl(image, size));
    }
  }

  /**
   * Loads and caches an image in the browsers cache.
   * @param {string} path - An image url
   */
  function loadImage(path) {
    new Image().src = path;
  }

  /**
   * Find the Shopify image attribute size
   *
   * @param {string} src
   * @returns {null}
   */
  function imageSize(src) {
    var match = src.match(/.+_((?:pico|icon|thumb|small|compact|medium|large|grande)|\d{1,4}x\d{0,4}|x\d{1,4})[_\.@]/);

    if (match) {
      return match[1];
    } else {
      return null;
    }
  }

  /**
   * Adds a Shopify size attribute to a URL
   *
   * @param src
   * @param size
   * @returns {*}
   */
  function getSizedImageUrl(src, size) {
    if (size === null) {
      return src;
    }

    if (size === 'master') {
      return this.removeProtocol(src);
    }

    var match = src.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i);

    if (match) {
      var prefix = src.split(match[0]);
      var suffix = match[0];

      return this.removeProtocol(prefix[0] + '_' + size + suffix);
    } else {
      return null;
    }
  }

  function removeProtocol(path) {
    return path.replace(/http(s)?:/, '');
  }

  return {
    preload: preload,
    loadImage: loadImage,
    imageSize: imageSize,
    getSizedImageUrl: getSizedImageUrl,
    removeProtocol: removeProtocol
  };
})();

/**
 * Variant Selection scripts
 * ------------------------------------------------------------------------------
 *
 * Handles change events from the variant inputs in any `cart/add` forms that may
 * exist. Also updates the master select and triggers updates when the variants
 * price or image changes.
 *
 * @namespace variants
 */

slate.Variants = (function() {

  /**
   * Variant constructor
   *
   * @param {object} options - Settings from `product.js`
   */
  function Variants(options) {
    this.$container = options.$container;
    this.product = options.product;
    this.singleOptionSelector = options.singleOptionSelector;
    this.originalSelectorId = options.originalSelectorId;
    this.enableHistoryState = options.enableHistoryState;
    this.currentVariant = this._getVariantFromOptions();

    $(this.singleOptionSelector, this.$container).on('change', this._onSelectChange.bind(this));
  }

  Variants.prototype = $.extend({}, Variants.prototype, {

    /**
     * Get the currently selected options from add-to-cart form. Works with all
     * form input elements.
     *
     * @return {array} options - Values of currently selected variants
     */
    _getCurrentOptions: function() {
      var currentOptions = $.map($(this.singleOptionSelector, this.$container), function(element) {
        var $element = $(element);
        var type = $element.attr('type');
        var currentOption = {};

        if (type === 'radio' || type === 'checkbox') {
          if ($element[0].checked) {
            currentOption.value = $element.val();
            currentOption.index = $element.data('index');

            return currentOption;
          } else {
            return false;
          }
        } else {
          currentOption.value = $element.val();
          currentOption.index = $element.data('index');

          return currentOption;
        }
      });

      // remove any unchecked input values if using radio buttons or checkboxes
      currentOptions = slate.utils.compact(currentOptions);

      return currentOptions;
    },

    /**
     * Find variant based on selected values.
     *
     * @param  {array} selectedValues - Values of variant inputs
     * @return {object || undefined} found - Variant object from product.variants
     */
    _getVariantFromOptions: function() {
      var selectedValues = this._getCurrentOptions();
      var variants = this.product.variants;
      var found = false;

      variants.forEach(function(variant) {
        var satisfied = true;

        selectedValues.forEach(function(option) {
          if (satisfied) {
            satisfied = (option.value === variant[option.index]);
          }
        });

        if (satisfied) {
          found = variant;
        }
      });

      return found || null;
    },

    /**
     * Event handler for when a variant input changes.
     */
    _onSelectChange: function() {
      var variant = this._getVariantFromOptions();

      this.$container.trigger({
        type: 'variantChange',
        variant: variant
      });

      if (!variant) {
        return;
      }

      this._updateMasterSelect(variant);
      this._updateImages(variant);
      this._updatePrice(variant);
      this.currentVariant = variant;

      if (this.enableHistoryState) {
        this._updateHistoryState(variant);
      }
    },

    /**
     * Trigger event when variant image changes
     *
     * @param  {object} variant - Currently selected variant
     * @return {event}  variantImageChange
     */
    _updateImages: function(variant) {
      var variantImage = variant.featured_image || {};
      var currentVariantImage = this.currentVariant.featured_image || {};

      if (!variant.featured_image || variantImage.src === currentVariantImage.src) {
        return;
      }

      this.$container.trigger({
        type: 'variantImageChange',
        variant: variant
      });
    },

    /**
     * Trigger event when variant price changes.
     *
     * @param  {object} variant - Currently selected variant
     * @return {event} variantPriceChange
     */
    _updatePrice: function(variant) {
      if (variant.price === this.currentVariant.price && variant.compare_at_price === this.currentVariant.compare_at_price) {
        return;
      }

      this.$container.trigger({
        type: 'variantPriceChange',
        variant: variant
      });
    },

    /**
     * Update history state for product deeplinking
     *
     * @param {object} variant - Currently selected variant
     */
    _updateHistoryState: function(variant) {
      if (!history.replaceState || !variant) {
        return;
      }

      var newurl = window.location.protocol + '//' + window.location.host + window.location.pathname + '?variant=' + variant.id;
      window.history.replaceState({path: newurl}, '', newurl);
    },

    /**
     * Update hidden master select of variant change
     *
     * @param {object} variant - Currently selected variant
     */
    _updateMasterSelect: function(variant) {
      $(this.originalSelectorId, this.$container)[0].value = variant.id;
    }
  });

  return Variants;
})();


/*================ Templates ================*/
/**
 * Product Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Product template.
 *
   * @namespace product
 */

theme.Product = (function() {

  var selectors = {
    addToCart: '[data-add-to-cart]',
    addToCartText: '[data-add-to-cart-text]',
    comparePrice: '[data-compare-price]',
    comparePriceText: '[data-compare-text]',
    originalSelectorId: '[data-product-select]',
    priceWrapper: '[data-price-wrapper]',
    productFeaturedImage: '[data-product-featured-image]',
    productJson: '[data-product-json]',
    productPrice: '[data-product-price]',
    productThumbs: '[data-product-single-thumbnail]',
    singleOptionSelector: '[data-single-option-selector]'
  };

  /**
   * Product section constructor. Runs on page load as well as Theme Editor
   * `section:load` events.
   * @param {string} container - selector for the section container DOM element
   */
  function Product(container) {
    this.$container = $(container);

    // Stop parsing if we don't have the product json script tag when loading
    // section in the Theme Editor
    if (!$(selectors.productJson, this.$container).html()) {
      return;
    }

    var sectionId = this.$container.attr('data-section-id');
    this.productSingleObject = JSON.parse($(selectors.productJson, this.$container).html());

    var options = {
      $container: this.$container,
      enableHistoryState: this.$container.data('enable-history-state') || false,
      singleOptionSelector: selectors.singleOptionSelector,
      originalSelectorId: selectors.originalSelectorId,
      product: this.productSingleObject
    };

    this.settings = {};
    this.namespace = '.product';
    this.variants = new slate.Variants(options);
    this.$featuredImage = $(selectors.productFeaturedImage, this.$container);

    this.$container.on('variantChange' + this.namespace, this.updateAddToCartState.bind(this));
    this.$container.on('variantPriceChange' + this.namespace, this.updateProductPrices.bind(this));

    if (this.$featuredImage.length > 0) {
      this.settings.imageSize = slate.Image.imageSize(this.$featuredImage.attr('src'));
      slate.Image.preload(this.productSingleObject.images, this.settings.imageSize);

      this.$container.on('variantImageChange' + this.namespace, this.updateProductImage.bind(this));
    }
  }

  Product.prototype = $.extend({}, Product.prototype, {

    /**
     * Updates the DOM state of the add to cart button
     *
     * @param {boolean} enabled - Decides whether cart is enabled or disabled
     * @param {string} text - Updates the text notification content of the cart
     */
    updateAddToCartState: function(evt) {
      var variant = evt.variant;

      if (variant) {
        $(selectors.priceWrapper, this.$container).removeClass('hide');
      } else {
        $(selectors.addToCart, this.$container).prop('disabled', true);
        $(selectors.addToCartText, this.$container).html(theme.strings.unavailable);
        $(selectors.priceWrapper, this.$container).addClass('hide');
        return;
      }

      if (variant.available) {
        $('.ajaxfeedback').remove();
        $(selectors.addToCart, this.$container).prop('disabled', false);
        $(selectors.addToCart, this.$container).removeClass('btn-sold-out');
        $(selectors.addToCartText, this.$container).html(theme.strings.addToCart);
      } else {
        //$(selectors.addToCart, this.$container).prop('disabled', true);
        $(selectors.addToCart, this.$container).addClass('btn-sold-out');
        //$(selectors.addToCart, this.$container).removeClass('variant-available');
        $(selectors.addToCartText, this.$container).html(theme.strings.soldOut);
      }
    },

    /**
     * Updates the DOM with specified prices
     *
     * @param {string} productPrice - The current price of the product
     * @param {string} comparePrice - The original price of the product
     */
    updateProductPrices: function(evt) {
      var variant = evt.variant;
      var $comparePrice = $(selectors.comparePrice, this.$container);
      var $compareEls = $comparePrice.add(selectors.comparePriceText, this.$container);

      $(selectors.productPrice, this.$container)
        .html(slate.Currency.formatMoney(variant.price, theme.moneyFormat));

      if (variant.compare_at_price > variant.price) {
        $comparePrice.html(slate.Currency.formatMoney(variant.compare_at_price, theme.moneyFormat));
        $compareEls.removeClass('hide');
      } else {
        $comparePrice.html('');
        $compareEls.addClass('hide');
      }
    },

    /**
     * Updates the DOM with the specified image URL
     *
     * @param {string} src - Image src URL
     */
    updateProductImage: function(evt) {
      var variant = evt.variant;
      var sizedImgUrl = slate.Image.getSizedImageUrl(variant.featured_image.src, this.settings.imageSize);

      this.$featuredImage.attr('src', sizedImgUrl);
    },

    /**
     * Event callback for Theme Editor `section:unload` event
     */
    onUnload: function() {
      this.$container.off(this.namespace);
    }
	});



//BG: Init slickSlider for Related Products.
function relatedSlickSlider(target) {
    $(target).slick({
        infinite: true,
        slidesToShow: 5,
        slidesToScroll: 5,
        arrows:true,
        dots: false,
        prevArrow: slickPrevArrow,
        nextArrow: slickNextArrow,
        responsive: [
            {
                breakpoint: 992,
                settings: {
                  slidesToShow: 3,
                  slidesToScroll: 3
              }
            },
            {
                breakpoint: 768,
                settings: {
                  slidesToShow: 2,
                  slidesToScroll: 2
              }
            }
        ]
    });
}


//BG: Make the call to the related products API
function relatedProductsAPI() {
var productID = $('.featured-products.related-products').attr('data-product-id');

    //Make the JSON request to the recommendations API, pass over the current product ID.
    $.getJSON('/recommendations/products.json?product_id='+productID+'&limit=8', function(data) {
        //for each product in the API Response, pass over to the output function.
        $.each(data.products,function(i, product) {
            //BG: outputProduct function used in settings/common.js. It's basic styling.
            outputProduct(product,'.featured-products.related-products');
            var increment = i + 1;

            //BG: if we've cycled through all products, trigger the slickInit
            if (data.products.length == increment) {
                //persistentCheck function in setting/common.js
                persistentCheck('.featured-products.related-products .featured-product',5,relatedSlickSlider,'.featured-products.related-products .featured-products-slick',5000);
            }
        });
    });
}
  
//Get URL Parameter
function getUrlParameter(name) {
	name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
	var regex = new RegExp('[\\?&]' + name + '=([^&#]*)');
	var results = regex.exec(location.search);
	return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
};

//BG: if variant parameter is available in the URL, change the selection based on this.
function changeProductByVariantID() {
	var variantID = getUrlParameter('variant');
	//console.log(variant);

    if (variantID) {
		$('.swatch [data-variant-id="'+variantID+'"]').find('input[type="radio"]').prop("checked", true);
		//console.log('test');
    }
}

//BG: Intended to work with the 'back in stock' app. Trigger via button
function notifyApp() {
  var soldOutBtn = $('.waiting-list-notification'),
      notifyBtn = $('.BIS_trigger');

      soldOutBtn.click(function(e){
        e.preventDefault();  
        notifyBtn.click();
      });
}

//BG: Intended to work with the 'back in stock' app. Trigger via soldout size label
function notifyAppTwo() {
  var soldOutLabel = $('.soldout > label'),
      notifyBtn = $('.BIS_trigger');

      soldOutLabel.click(function(e){
        e.preventDefault();  
        notifyBtn.click();
      });
}

//BG: Intended to work with the 'back in stock' app. Trigger when all sizes are soldout
function notifyNoSizes() {
  if (!$('.swatch-element').hasClass('available')) {
    $('.BIS_trigger').click();
  }
}

function stockLevel() {
  $('.size-swatch-option li').each(function(){
     var variantStockLevel = $(this).attr('data-stock-level');

     $(this).on('change', function(){
        $('.inventory-quantity-warning span').html(variantStockLevel);

        if(variantStockLevel > 0 && variantStockLevel <=3 ) {
          $('.inventory-quantity-warning').addClass('active');
        } else {
          $('.inventory-quantity-warning').removeClass('active');
        }
     });
  });
}
	
  
  //Accordion Functionality.
function accordionToggle() {
	var accordionTitle = $('.accordion-title');
	
	$('.accordion-item.active .accordion-content').show();
	
	accordionTitle.click(function(){
		if ($(this).parent('.accordion-item').hasClass('active')) {
			$(this).parent('.accordion-item').removeClass('active');
			$(this).next('.accordion-content').slideUp();
		} else {
			
			$('.accordion-item').removeClass('active');
			$('.accordion-content').slideUp();
			
			$(this).parent('.accordion-item').addClass('active');
			$(this).next('.accordion-content').slideDown();
		}
	})
}

function sizeguideSelect() {
	var sizeTabs = $('.size-guide-frame .size-tabs li a'),
		sizeSelect = $('.size-guide-frame .size-tabs-select select'),
		sizeTable = $('.size-tab');

	$(sizeTabs).click(function(e){
		e.preventDefault();
		var tableOption = $(this).attr('data-option');

		$(sizeTable).removeClass('active');
		$(sizeTabs).parent('li').removeClass('active');

		$(sizeSelect).val(tableOption).change();

		$(this).parent('li').addClass('active');
		$('.size-guide-frame table[data-table="'+tableOption+'"]').addClass('active');
	});

	$(sizeSelect).on('change', function(){
    var tableOption = $(this).val();
    
    console.log(tableOption);
		
		$(sizeTable).removeClass('active');
		$(sizeTabs).parent('li').removeClass('active');

		$('.size-guide-frame .size-tabs li a[data-option="'+tableOption+'"]').parent('li').addClass('active');

		$('.size-guide-frame .size-tab[table-option="'+tableOption+'"]').addClass('active');

	});
}

function sizeguideModal() {
    var closeIcon = $('.size-guide-frame .size-guide-close'),
		sizeguideOverlay = $('.size-guide-overlay'),
		sizeguideFrame = $('.size-guide-frame'),
		sizeguideOpen = $('.template-product .sizing-help');

    $(closeIcon).click(function(){
        $(sizeguideFrame).removeClass('active');
        $(sizeguideOverlay).removeClass('active');
        $('body').removeClass('no-scroll');
    })

    $(sizeguideOpen).click(function(){
        $(sizeguideFrame).addClass('active');
        $(sizeguideOverlay).addClass('active');
        $('body').addClass('no-scroll');
    })
}

//Checks to see if any colours are in the related_colours element, if there are then show the main colours div.
function colourChecker() {
  var productColoursContainer = document.querySelector('.product-related-colours');
  var productColours = document.querySelectorAll('.product-related-colours li');

  if (productColours.length > 0) {
    //Shows main container
    productColoursContainer.classList.add('active');
  }
}

function productSlick() {
    $('.product-detail-images').slick({
       slidesToShow: 1,
       slidesToScroll: 1,
       infinite: false,
       prevArrow: slickPrevArrow,
       nextArrow: slickNextArrow,
       arrows: true,
       dots: true,
       draggable: false,
       touchMove: false,
       swipe: true,
       swipeToSlide: true
   });
}

function whatsappIcon() {
    //if user on mobile
    if( /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) ) {
        $('.social-sharing-products .whatsapp').removeClass('d-none');
    }
}

function mobileProductReOrder() {
  if ($(window).width() < screenMD) {
    $('.product-detail-primary-images').insertBefore('.desktop-title');
    $('.right-col-inner-wrapper').insertBefore('.accordion-container');
    $('.accordion-container').addClass('active');
	} else {
    $('.product-detail-primary-images').appendTo('.product-detail-image-container');
    $('.right-col-inner-wrapper').appendTo('.right-col-wrapper');
  }

  var initalWindow = $(window).width();
  $(window).resize(function(){
      var newWindow = $(window).width(); 
      if(initalWindow!==newWindow){
        if ($(window).width() < screenMD) {
          $('.product-detail-primary-images').insertBefore('.desktop-title');
          $('.right-col-inner-wrapper').insertBefore('.accordion-container');
        } else {
          $('.product-detail-primary-images').appendTo('.product-detail-image-container');
          $('.right-col-inner-wrapper').appendTo('.right-col-wrapper');
        }
      }
  });

}

function productZoom() {
  $('.template-product .product-image').each(function(){
    var largerImage = $(this).find('img').attr('data-zoom-img');

    $(this).zoom({
      url: largerImage
    }); 

  });
 }

 function multipleOption() {
    var sizeOptions = [];

    $('select[name="id"] option').each(function(){
        var optionName = $(this).attr('data-option');

        if(sizeOptions.indexOf(optionName) == -1) {
          sizeOptions.push(optionName);
        }
    });

    $.each(sizeOptions,function(i, size) {
        //console.log('Size: '+size);
        var sizeQuantity = false;
        $('select[name="id"] option[data-option="'+size+'"]').each(function(){
            var variantLength = $(this).attr('data-option-two');
            var variantQuantity = $(this).attr('data-quantity');

            if (variantQuantity > 0) {
                sizeQuantity = true;
            }

            //console.log('Length:'+ variantLength + ' Quantity:' + variantQuantity);
        });

        if (sizeQuantity == false) {
            $('.size-option-choice li[value="'+size+'"]').addClass('soldout'); 
        }
        //console.log('Quantity available?' + sizeQuantity);
    });
 }

 function lengthChange() {
    var sizeOption = $('.size-option-SIZE li');

    $(sizeOption).each(function(){

      //MJ: If all lengths options for a specific size are sold out, add the soldout class to that size
      var variantOption = $(this).attr('data-value'),
      howManyNotSoldOut = $('.size-option-LENGTH li[data-size="'+variantOption+'"]:not(.soldout)').length;

      if (howManyNotSoldOut == 0) {
        $(this).addClass('soldout');
      }

      if(!$(this).hasClass('soldout')) {
        $(this).off().on('click', function(){
          var variantOption = $(this).attr('data-value');
  
          $(sizeOption).removeClass('active');
          $(this).addClass('active');
          $('.size-option-LENGTH').addClass('active');
  
          $('.size-option-LENGTH li').removeClass('active-option');
          $('.size-option-LENGTH li[data-size="'+variantOption+'"]').addClass('active-option');

          $('.step-guides .size').addClass('hide');
          $('.step-guides .length').addClass('show');
        })
      }
    });
 }

 function lengthOption() {
    
    var lengthOption = $('.size-option-LENGTH li');

    $(lengthOption).each(function(){
      if(!$(this).hasClass('soldout')) {
        $(this).off().on('click', function(){
          var optionID = $(this).attr('data-value');
          var variantStockLevel = $(this).attr('data-stock-level');
  
          $(lengthOption).removeClass('active');
          $(this).addClass('active');
          $('select[data-product-select] option').attr("selected", false);
          $('select[data-product-select] option[value="'+optionID+'"]').attr("selected", true);
          $('.btn-add-to-cart').removeAttr('disabled');
          $('.step-guides .length').addClass('hide');

          $('.preorder-message').removeClass('show');
          $('.preorder-message[data-variant-id="' + optionID + '"]').addClass('show');

          $('.inventory-quantity-warning span').html(variantStockLevel);

          if(variantStockLevel > 0 && variantStockLevel <=3 ) {
            $('.inventory-quantity-warning').addClass('active');
          } else {
            $('.inventory-quantity-warning').removeClass('active');
          }
        })
      }
    });
 }

 function singularSizeOption() {
   var singularSize = $('.size-option-singular li');
   $(singularSize).each(function(){
    if(!$(this).hasClass('soldout')) {
      $(this).off().on('click', function(){
        var optionID = $(this).attr('data-value');
        var variantStockLevel = $(this).attr('data-stock-level');

        $(singularSize).removeClass('active');
        $(this).addClass('active');
        $('select[data-product-select] option').attr("selected", false);
        $('select[data-product-select] option[value="'+optionID+'"]').attr("selected", true);

        $('.preorder-message').removeClass('show');
        $('.preorder-message[data-variant-id="' + optionID + '"]').addClass('show');

        $('.inventory-quantity-warning span').html(variantStockLevel);

        if(variantStockLevel > 0 && variantStockLevel <=3 ) {
          $('.inventory-quantity-warning').addClass('active');
        } else {
          $('.inventory-quantity-warning').removeClass('active');
        }
      })
    }
  });
 }

 function preorderVariant() {

  $('.size-swatch-option li').each(function(){
      var variantStockLevel = $(this).attr('data-value');

      $(this).on('change', function(){
        $('.preorder-message').removeClass('show');

        $('.preorder-message[data-value="' + variantStockLevel + '"]').addClass('show');
      });
  });

}

function loyaltylionpopup() {
  $('.loyalty-lion-popup-button').on('click', function(){
    $(this).addClass('active');
    $('.loyalty-lion-popup').addClass('active');
    $('#popup-overlay').addClass('active');
  })

  $('.loyalty-lion-popup .loyalty-lion-close-button').on('click', function(){
    $('.loyalty-lion-popup-button').removeClass('active');
    $('.loyalty-lion-popup').removeClass('active');
    $('#popup-overlay').removeClass('active');
  })
}
	
//BG: Only run on Product Page.
if ($('body.template-product').length) {

    changeProductByVariantID();
  	sizeguideSelect();
    sizeguideModal();
    //relatedProductsAPI();
    productSlick();
    whatsappIcon();
    mobileProductReOrder();
    //stockLevel();
    productZoom();
    multipleOption();
    lengthChange();
    lengthOption();
    singularSizeOption();
    //preorderVariant();
    loyaltylionpopup();
    
    //BG: App related functions for Product Page
    persistentCheck('.BIS_trigger',0,notifyApp,'nothing',10000);

  }

  accordionToggle();

  return Product;
})();

/**
 * Customer Addresses Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Customer Addresses
 * template.
 *
 * @namespace customerAddresses
 */

theme.customerAddresses = (function() {
  var $newAddressForm = $('#AddressNewForm');

  if (!$newAddressForm.length) {
    return;
  }

  // Initialize observers on address selectors, defined in shopify_common.js
  if (Shopify) {
    new Shopify.CountryProvinceSelector('AddressCountryNew', 'AddressProvinceNew', {
      hideElement: 'AddressProvinceContainerNew'
    });
  }

  // Initialize each edit form's country/province selector
  $('.address-country-option').each(function() {
    var formId = $(this).data('form-id');
    var countrySelector = 'AddressCountry_' + formId;
    var provinceSelector = 'AddressProvince_' + formId;
    var containerSelector = 'AddressProvinceContainer_' + formId;

    new Shopify.CountryProvinceSelector(countrySelector, provinceSelector, {
      hideElement: containerSelector
    });
  });

  // Toggle new/edit address forms
  $('.address-new-toggle').on('click', function() {
    $newAddressForm.toggleClass('hide');
	  
	if ($(this).hasClass('address-new-primary')) {
		$(this).addClass('hide');
	}
	  
	if ($(this).hasClass('address-new-secondary')) {
		$('.address-new-primary').removeClass('hide');
	}
	  
  });

  $('.address-edit-toggle').on('click', function() {
    var formId = $(this).data('form-id');
    $('#EditAddress_' + formId).toggleClass('hide');
	  
	if ($(this).hasClass('address-edit-primary')) {
		$(this).addClass('hide');
	}
	  
	if ($(this).hasClass('address-edit-secondary')) {
		$('.address-edit-primary').removeClass('hide');
	}
  });

  // $('.address-delete').on('click', function() {
  //   var $el = $(this);
  //   var formId = $el.data('form-id');
  //   var confirmMessage = $el.data('confirm-message');
  //   if (confirm(confirmMessage || 'Are you sure you wish to delete this address?')) {
  //     Shopify.postLink('/account/addresses/' + formId, {parameters: {_method: 'delete'}});
  //   }
  // });
})();

/**
 * Password Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Password template.
 *
 * @namespace password
 */

theme.customerLogin = (function() {
  var config = {
    recoverPasswordForm: '#RecoverPassword',
    hideRecoverPasswordLink: '#HideRecoverPasswordLink'
  };

  if (!$(config.recoverPasswordForm).length) {
    return;
  }

  checkUrlHash();
  resetPasswordSuccess();

  $(config.recoverPasswordForm).on('click', onShowHidePasswordForm);
  $(config.hideRecoverPasswordLink).on('click', onShowHidePasswordForm);

  function onShowHidePasswordForm(evt) {
    evt.preventDefault();
    toggleRecoverPasswordForm();
  }

  function checkUrlHash() {
    var hash = window.location.hash;

    // Allow deep linking to recover password form
    if (hash === '#recover') {
      toggleRecoverPasswordForm();
    }
  }

  /**
   *  Show/Hide recover password form
   */
  function toggleRecoverPasswordForm() {
    $('#RecoverPasswordForm').toggleClass('hide');
    $('#CustomerLoginForm').toggleClass('hide');
  }

  /**
   *  Show reset password success message
   */
  function resetPasswordSuccess() {
    var $formState = $('.reset-password-success');

    // check if reset password form was successfully submited.
    if (!$formState.length) {
      return;
    }

    // show success message
    $('#ResetSuccess').removeClass('hide');
  }
})();

//Get URL Parameters 
function getUrlParameter(name) {
    name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
    var regex = new RegExp('[\\?&]' + name + '=([^&#]*)');
    var results = regex.exec(location.search);
    return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
};

//create Cookie
function setCookie(name,value,days) {
	var expires = "";
	if (days) {
		var date = new Date();
		date.setTime(date.getTime() + (days*24*60*60*1000));
		expires = "; expires=" + date.toUTCString();
	}
	document.cookie = name + "=" + (value || "")  + expires + "; path=/";
}

//Get cookie value
function getCookie(name) {
	var nameEQ = name + "=";
	var ca = document.cookie.split(';');
	for(var i=0;i < ca.length;i++) {
		var c = ca[i];
		while (c.charAt(0)==' ') c = c.substring(1,c.length);
		if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length,c.length);
	}
	return null;
}

//Delete cookie
function eraseCookie(name) {
	document.cookie = name+'=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/';
}


function collectionReadMore() {
	var readmoreBtn = $('.collection-read-more'),
		collectionDescription = $('.second-description'),
		collectionDescriptionHeightInitial = collectionDescription.height();

		if(collectionDescriptionHeightInitial > 54) {
			$(collectionDescription).addClass('fade');
			$(readmoreBtn).addClass('fade');

			collectionDescriptionHeight = collectionDescription.height();

			readmoreBtn.off('click').on('click', function(e){

				if (readmoreBtn.hasClass('active')) {
		
					collectionDescription.removeClass('active');
		
					collectionDescription.animate({
						height: collectionDescriptionHeight
					}, 1000, function(){
						readmoreBtn.removeClass('active');
					});
		
					readmoreBtn.text('Read More');
		
				} else {
		
					collectionDescription.addClass('active');
		
					collectionDescription.animate({
						height: collectionDescription.get(0).scrollHeight
					}, 1000, function(){
						$(this).height('auto');
						readmoreBtn.addClass('active');
					});
		
					readmoreBtn.text('Read Less');
		
				}
		
			});
		} 
}

function filterToggle() {
	var filterTitle = $('.filter-title'),
		filterSidebar = $('.filter-sidebar'), 
		filterClose = $('.filter-close-icon'); 

	if ($(window).width() <= screenMD) {

		filterTitle.off('click').on('click', function(){
			if ($(this).hasClass('active')) {
				$(this).removeClass('active');
				filterSidebar.slideUp();
			} else {
				$(this).addClass('active');
				filterSidebar.slideDown();
			}
		});
	}
}

//BG: For each product, find the related product colour and link to it.
function collectionProductColours() {
	var collectionProducts = $('.collection-listing .product-single');

	//Loop through the product list, and get the productID for each product. The loop through the second list of products, and match them based on the productGroup.
	collectionProducts.each(function(){
	var productID = $(this).attr('data-product-id'),
		productGroup = $('.collection-product-colours li[data-product-id="'+productID+'"]').attr('data-product-group'),
		productGroupCollection = $('.collection-product-colours li[data-product-group="'+productGroup+'"]');

		//Loop through the product grouping, and append the products to their related grouping.
		productGroupCollection.each(function(){
			var thisProductID = $(this).attr('data-product-id'),
				thisProductColour = $(this).attr('data-product-colour'),
				thisProductImage = $(this).attr('data-product-image-large'),
				thisProductImageSecondary = $(this).attr('data-product-image-secondary'),
				thisProductURL = $(this).attr('data-product-url');

				if (thisProductID == productID) {
					thisProductColour = thisProductColour + " primary-product active";
				}

				var list = '<li class="'+thisProductColour+'" data-product-id="'+thisProductID+'" data-product-image="'+thisProductImage+'" data-product-image-secondary="'+thisProductImageSecondary+'" data-product-url="'+thisProductURL+'"></li>';

			//if product has colour....then append it.
			if (thisProductColour) {	
				if (thisProductID == productID) {
					$('.collection-listing .product-single[data-product-id="'+productID+'"] .product-colours ul').prepend(list);
				} else {
					$('.collection-listing .product-single[data-product-id="'+productID+'"] .product-colours ul').append(list);
				}
			}

			//if more than one colour, show colours.
			if ($('.collection-listing .product-single[data-product-id="'+productID+'"] .product-colours li').length > 1) {
				$('.collection-listing .product-single[data-product-id="'+productID+'"] .product-colours').removeClass('d-none');
			}
		});
	})
}

//BG: used in conjuction with the above function, once the above function has ran, we then need to allow the user to switch between the colours, and show image and update the product link.
function collectionProductColourSwitcher() {
	var productColours = $('.collection-listing .product-colours li'),
		interactionType = "";

	if ($(window).width() <= screenMD) {
		interactionType = "click";
	} else {
		interactionType = "mouseover";
	}

	productColours.on(interactionType, function() {
		var productImage = $(this).attr('data-product-image'),
			productImageSecondary = $(this).attr('data-product-image-secondary'),
			productURL = $(this).attr('data-product-url'),
			productID = $(this).attr('data-product-id'),
			parentProductID = $(this).closest('#product_single').attr('data-product-id'),
			productColours = $(this).closest('#product_single').find('.product-colours li'),
			primaryImage = $(this).closest('#product_single').find('.product-image img'),
			parentProductURL = $(this).closest('#product_single').find('a'),
			quickView = $(this).closest('#product_single').find('.product-quickview span');

			productColours.removeClass('active');
			$(this).addClass('active');

			primaryImage.attr('src', productImage);
			primaryImage.attr('data-second-image', productImageSecondary);
			parentProductURL.attr('href', productURL);
			quickView.attr('data-product-url', productURL);
	});
}

//On the initial page load, set the sorting option to the first option.
function sortFilter() {
	if (!getUrlParameter('sort')) {
		$( window ).one( "load", function() {
			$('#bc-sf-filter-top-sorting select option:first').attr("selected",true);
		});
	}
}

// LM: Adding an identifier to the double image element.
function doubleImage() {
	$('.product-single:nth-child(5n + 1)').addClass('doubleImage'); 
}

//LM: Changing the method of adding a second image. Rather than loading in the image as default, i'm loading in the URL to the second image, and will load it on hover. Only works on items without the double image layout for now. Hover for this is applied in a later funtion.
function collectionProductHover() {

	$('.collection-listing .product-single').each(function(){
		if(!$(this).hasClass('doubleImage')) {
			$(this).find('.product-image-hover img').off().on("mouseenter", function(){
				var firstImage = $(this).attr('data-src'),
					secondImage = $(this).attr('data-second-image');
					
					$(this).attr('data-src',secondImage);
					$(this).attr('src',secondImage);
					$(this).attr('data-srcset',secondImage);
					$(this).attr('srcset',secondImage);
					$(this).attr('data-second-image',firstImage);
			});

			$(this).find('.product-image-hover img').on("mouseleave", function(){
				var secondImage = $(this).attr('data-src'),
					firstImage = $(this).attr('data-second-image');
					
					$(this).attr('data-src',firstImage);
					$(this).attr('src',firstImage);
					$(this).attr('data-srcset',firstImage);
					$(this).attr('srcset',firstImage);
					$(this).attr('data-second-image',secondImage);
			});
		}
	});
}

// LM Function to change the layout of collection using icons. Depending on what layout is rendered. Image hover is applied to the double image layout items.
function collectionViews() {
	var collectionViewSelect = $('.collection-view li'),
		collectionView = $('#bc-sf-filter-products');

	if (getCookie('collectionView')) {
		collectionView.attr('class','row collection-view-three');
		collectionViewSelect.removeClass('active');
		$('.collection-view li.collection-view-three').addClass('active');
	}

	collectionViewSelect.click(function(){
		var collectionViewClass = $(this).attr('class').split(' ')[0];

		collectionViewSelect.removeClass('active');
		$(this).addClass('active');

		collectionView.attr('class','row '+collectionViewClass);

		if (collectionViewClass === 'collection-view-three' ) {
			setCookie('collectionView','three', 365)
		} else {
			eraseCookie('collectionView');
		}

		if($('#bc-sf-filter-products').hasClass('collection-view-three')) {
			$('.doubleImage .product-image-hover img').off().on("mouseenter", function(){
				var firstImage = $(this).attr('data-src'),
					secondImage = $(this).attr('data-second-image');
					
					$(this).attr('data-src',secondImage);
					$(this).attr('src',secondImage);
					$(this).attr('data-srcset',secondImage);
					$(this).attr('srcset',secondImage);
					$(this).attr('data-second-image',firstImage);
			});
			$('.doubleImage .product-image-hover img').on("mouseleave", function(){
				var secondImage = $(this).attr('data-src'),
					firstImage = $(this).attr('data-second-image');
					
					$(this).attr('data-src',firstImage);
					$(this).attr('src',firstImage);
					$(this).attr('data-srcset',firstImage);
					$(this).attr('srcset',firstImage);
					$(this).attr('data-second-image',secondImage);
			});
		} else {
			$('.doubleImage .product-image-hover img').off().on("mouseenter", function(){
				var firstImage = $(this).attr('data-src'),
					secondImage = $(this).attr('data-second-image');
					
					$(this).attr('data-src',firstImage);
					$(this).attr('src',firstImage);
					$(this).attr('data-srcset',firstImage);
					$(this).attr('srcset',firstImage);
					$(this).attr('data-second-image',secondImage);
			});
		}
	});
}

// LM: On inital load if the collection view three layout is loaded then apply the image hover to the double image elements.
function initialDoubleImageLoad() {
	if($('#bc-sf-filter-products').hasClass('collection-view-three')) {
		console.log('three-good');
		$('.doubleImage .product-image-hover img').off().on("mouseenter", function(){
			var firstImage = $(this).attr('data-src'),
				secondImage = $(this).attr('data-second-image');
				
				$(this).attr('data-src',secondImage);
				$(this).attr('src',secondImage);
				$(this).attr('data-srcset',secondImage);
				$(this).attr('srcset',secondImage);
				$(this).attr('data-second-image',firstImage);
		});
		$('.doubleImage .product-image-hover img').on("mouseleave", function(){
			var secondImage = $(this).attr('data-src'),
				firstImage = $(this).attr('data-second-image');
				
				$(this).attr('data-src',firstImage);
				$(this).attr('src',firstImage);
				$(this).attr('data-srcset',firstImage);
				$(this).attr('srcset',firstImage);
				$(this).attr('data-second-image',secondImage);
		});
	} 
}

//BG: if the inline CTA is available, let's place it within the colleciton listings.
function inlineCTA() {
    if ($('.collection-inline-cta').length) {
        var ctaMarkup = $('.collection-inline-cta-container').html(),
            position = $('.collection-inline-cta').attr('data-cta-position'),
            collectionListing = $('#bc-sf-filter-products div.product-single:nth-child('+position+')');

        //BG:  only add the CTA if it hasn't been added already
        if ($('#bc-sf-filter-products .product-cta-inline').length <= 0) {
            collectionListing.after('<div class="product-single product-cta-inline">' + ctaMarkup + '</div>');
        }
    }
}

collectionReadMore();
filterToggle();
//doubleImage();
//collectionProductHover();
collectionViews();

//Update the quantity field on the cart page. Based on plus and minus buttons.
function cartQuantity() {
	var cartQuantity = $('.cart-product-quantity');

	
	cartQuantity.each(function(){
		var quantityUp = $(this).find('.quantity-up'),
			quantityDown = $(this).find('.quantity-down'),
			quantityValue = $(this).find('.cart-item__qty');
		
		
		quantityUp.on('click',function(){

			var currentVal = parseInt(quantityValue.val());
			if (!isNaN(currentVal)) {
				quantityValue.val(currentVal + 1);
			}
			$('.btn-cart-update').click();
		});
		quantityDown.on('click',function(){
			var currentVal = parseInt(quantityValue.val());
			if (!isNaN(currentVal) && currentVal > 1) {
				quantityValue.val(currentVal - 1);
			}
			$('.btn-cart-update').click();
		});
		
		quantityValue.bind('input',function() {
			$('.btn-cart-update').click();
		});
	});

}


function cartQuantitySelect() {
	var cartQuantity = $('.product-quantity');

	cartQuantity.each(function(){
		var quantitySelect = $(this).find('.product-quantity-select'),
			quantityValue = $(this).find('.product-quantity-value').attr('value'),
			quantityInput = $(this).find('.product-quantity-value');

		//On initial load, set the dropdown to reflect the current quantity.	
		quantitySelect.find('[value="'+quantityValue+'"]').attr('selected', true);

		// LM Once quantity has been changed, need to update input value beneath so checkout quanity is updated as well.
		quantitySelect.on('change', function(){
			var selectedValue = $(this).find(':selected').attr('value');
			var selectedInput = $(this).next();

			$(selectedInput).attr('value', selectedValue);
		});
	});
}

function cartReorder() {

	$('.basket-item').each(function(){
		var basketActions = $(this).find('.basket-actions'),
			basketItemDetails = $(this).find('.basket-item-details');

		if ($(window).width() > screenMD) {
			$(basketActions).appendTo(basketItemDetails);
		} else {
			$(basketActions).insertAfter(basketItemDetails);
		}
		
		$(window).on('resize', function() {
			if ($(window).width() > screenMD) {
				$(basketActions).appendTo(basketItemDetails);
			} else {
				$(basketActions).insertAfter(basketItemDetails);
			}
		}); 
	});
}

//cartQuantity();
cartQuantitySelect();
cartReorder();
function forgotPassword() {

	var loginForm = $('#CustomerLoginForm'),
		passwordForm = $('#RecoverPasswordForm');

	$('.show-forgot-password').click(function(){
		loginForm.addClass('hide');
		passwordForm.removeClass('hide');
	});

	$('.hide-forgot-password').click(function(){
		loginForm.removeClass('hide');
		passwordForm.addClass('hide');
	});
}

function resetPasswordForm() {
	var formState = $('.reset-password-success')

	if (formState.length) {
		$('#ResetSuccess').removeClass('hide');
	}
}


//BG: Tokyo Laundry want to capture Birthdays.
function birthdayFormat(form) {
    var birthdayField = form.find('#Birthday'),
        birthdayFieldValue = 'Day/Month/Year',
        birthdayDay = form.find('#birthday-day'),
        birthdayDayValue = '',
        birthdayMonth = form.find('#birthday-month'),
        birthdayMonthValue = '',
        birthdayYear = form.find('#birthday-year'),
        birthdayYearValue = '';
    
    function combinedValue() {
        birthdayFieldValue = birthdayDayValue +' '+birthdayMonthValue +' '+ birthdayYearValue;
        birthdayField.val(birthdayFieldValue);
    }    

    birthdayDay.on('change', function(){
        birthdayDayValue = $(this).val();
        combinedValue();
    });

    birthdayMonth.on('change', function(){
        birthdayMonthValue = $(this).val();
        combinedValue();
    });

    birthdayYear.on('change', function(){
        birthdayYearValue = $(this).val();
        combinedValue();
    });
}

//BG: Check to see if the form is valid.
function checkFormValidation(form) {
    var invalidFields = form.find('label.required'),
        invalidFieldsCount = 0,
        validFieldsCount = 0;

    invalidFields.each(function(){
        if ($(this).hasClass('validated')) {
            validFieldsCount++;
        } else {
            invalidFieldsCount++;
        }
    });
    if (invalidFieldsCount === 0) {
        form.removeClass('validation-invalid');
    }

    console.log('invalid count:'+invalidFieldsCount);
    console.log('valid count:' +validFieldsCount);
}

//BG: build error message, what the message contains and where it should output.
function feedbackMessage(field, status, message,form) {
    var messageNoWhitespace = field.replace(/\s/g, ""),
        html = "<div class='ajaxfeedback "+status+" "+messageNoWhitespace+"'>"+message+"</div>";

    //if error messages are already showing, don't show again.
    if ($('.ajaxfeedback.' + messageNoWhitespace).length == 0) {
        form.before(html);
    }
}

function confirmPasswords(form) {
    $('#CreatePassword').on('input', function(){
        var passwordOneValue = $('#PasswordOne').val(),
            passwordTwoValue = $('#CreatePassword').val();

        if (passwordOneValue != passwordTwoValue) {
            $('.ajaxfeedback.Password').remove();
            feedbackMessage('Password','error','Passwords do not match',form);
            $('label.password-required').removeClass('validated');
        } else {
            $('.ajaxfeedback.Password').remove();
            $('label.password-required').addClass('validated');
            feedbackMessage('Password','success','Passwords match',form);
            checkFormValidation(form);
        }
    });  
}


//BG: Check input values
function checkRequiredFields(form) {
    var formFields = form.find('input.required:not(.password-required)'),
        passwordFields = form.find('input.password-required');

    //For each required field....
    formFields.each(function(){
        //on input should detect: paste, right click, deleting text or typing text. 
        $(this).on('input', function(){
            var thisValue = $(this).val(),
                label = $(this).attr('id'),
                labelNoWhitespace = label.replace(/\s/g, "");

            //If the value is greater than 0
            //add valid input classes and remove invalid messages
            if (thisValue.length > 0) {
                $(this).addClass('input-valid');
                $(this).removeClass('input-invalid');
                $('label[for="' + labelNoWhitespace + '"]').addClass('validated')
                $('.ajaxfeedback.'+labelNoWhitespace).remove();
                checkFormValidation(form);
            } else {
                $(this).removeClass('input-valid');
                $(this).addClass('input-invalid');
                $('label[for="' + labelNoWhitespace + '"]').removeClass('validated')
            }
        });
    });

    if (passwordFields.length > 0) {
        confirmPasswords(form);
    }
}

//Highlighted the required fields to the user, and output error message.
function highlightRequiredFields(form) {
    //get list of labels
    var invalidFormLabels = form.find('label.required:not(.validated)'),
        once = 0;

    invalidFormLabels.each(function(){
        if ($(this).hasClass('password-required')) {
            //Run once
            if (once == 0) {
                feedbackMessage('Password','error','<strong>Password</strong> this field is required.',form);
                once++;
            }
        } else {
            var labelValue = $.trim($(this).text());
            feedbackMessage(labelValue,'error','<strong>'+labelValue+'</strong> this field is required.',form)
        }
    })

}

/* 
BG: Basic form validation intended for the registration form.
*/
function registrationFormValidation() {
    var registrationForm = $('#create_customer');

    checkRequiredFields(registrationForm);
    birthdayFormat(registrationForm);

    registrationForm.on('submit', function(e) {
        //If class is present, don't submit form.
        if ($(this).hasClass('validation-invalid')) {
            e.preventDefault();
            highlightRequiredFields(registrationForm);
        } 
    });
}

function addressEditDelete() {

    //Delete Address, confirm user action.    
    $('.address-delete').on('click', function() {
        var $el = $(this);
        var formId = $el.data('form-id');
        var confirmMessage = $el.data('confirm-message');
        if (confirm(confirmMessage || 'Are you sure you wish to delete this address?')) {
            Shopify.postLink('/account/addresses/' + formId, {parameters: {_method: 'delete'}});
        }
    });
    
    //Toggle edit address
    $('.edit-address').on('click', function() {
        var formId = $(this).attr('data-form-id');
        $('#EditAddress_' + formId).toggleClass('hide');
          
        if ($(this).hasClass('address-edit-primary')) {
            $(this).addClass('hide');
        }
          
        if ($(this).hasClass('address-edit-secondary')) {
            $('.address-edit-primary').removeClass('hide');
        }
    });
}

function accountNavigation() {
    var accountSidebarTitle = $('.account-sidebar h3'),
        accountSidebarNavigation = $('.account-sidebar-navigation');

   accountSidebarTitle.on('click', function(){
        accountSidebarTitle.toggleClass('active');
        accountSidebarNavigation.toggleClass('active');
   });   
}

addressEditDelete();
resetPasswordForm();
forgotPassword();
registrationFormValidation();
accountNavigation();
function sidebarLinks() {
	var sidebarTitle = $('.sidebar-title'),
		sidebarContent = $('.sidebar-content');

	if ($(window).width() <= screenMD) {
		
		sidebarTitle.off('click').on('click', function(){
			if ($(this).hasClass('active')) {
				$(this).removeClass('active');
				$(this).next('.sidebar-content').slideUp();
			} else {
				$(this).addClass('active');
				$(this).next('.sidebar-content').slideDown();
			}
		});
		
	} else {
		sidebarTitle.off('click');
		sidebarContent.css('display', '');
	}
}

function searchSuggestionMove() {
	$('.bc-sf-search-suggestion').appendTo('.search-suggestion-wrapper')
}

function helpPageSelect() {
	var helpCurrent = $('.help-page-current'),
		helpOptions = $('.help-page-select');

		helpCurrent.off('click').on('click', function(){
		if ($(this).hasClass('active')) {
			$(this).removeClass('active');
			helpOptions.slideUp();
		} else {
			$(this).addClass('active');
			helpOptions.slideDown();
		}
	});
}

//Accordion Functionality for help page
function helpAccordionToggle() {
	var accordionTitle = $('.help-accordion-title');

	if ($(window).width() <= screenMD) {
		$('.help-accordion-item.active .help-accordion-content').show();
	
		accordionTitle.click(function(){
			if ($(this).parent('.help-accordion-item').hasClass('active')) {
				$(this).parent('.help-accordion-item').removeClass('active');
				$(this).next('.help-accordion-content').slideUp();
			} else {
				
				$('.help-accordion-item').removeClass('active');
				$('.help-accordion-content').slideUp();
				
				$(this).parent('.help-accordion-item').addClass('active');
				$(this).next('.help-accordion-content').slideDown();
			}
		})
	} 
}

//Accordion Functionality for FAQ page
function FAQAccordionToggle() {
	var accordionTitle = $('.faq-accordion-title');

	$('.faq-accordion-item.active .faq-accordion-content').show();
	
		accordionTitle.click(function(){
			if ($(this).parent('.faq-accordion-item').hasClass('active')) {
				$(this).parent('.faq-accordion-item').removeClass('active');
				$(this).next('.faq-accordion-content').slideUp();
			} else {
				
				$('.faq-accordion-item').removeClass('active');
				$('.faq-accordion-content').slideUp();
				
				$(this).parent('.faq-accordion-item').addClass('active');
				$(this).next('.faq-accordion-content').slideDown();
			}
		})
}

//Accordion Functionality for Loyalty page
function LoyaltyAccordionToggle() {
	var accordionTitle = $('.loyalty-accordion-title');

	$('.loyalty-accordion-item.active .loyalty-accordion-content').show();
	
		accordionTitle.click(function(){
			if ($(this).parent('.loyalty-accordion-item').hasClass('active')) {
				$(this).parent('.loyalty-accordion-item').removeClass('active');
				$(this).next('.loyalty-accordion-content').slideUp();
			} else {
				
				$('.loyalty-accordion-item').removeClass('active');
				$('.loyalty-accordion-content').slideUp();
				
				$(this).parent('.loyalty-accordion-item').addClass('active');
				$(this).next('.loyalty-accordion-content').slideDown();
			}
		})
}

function deliveryCountryDropdown() {
	// LM: On initial load, get the selected country option.
	var countrySelected = $('.country-select select option:selected').attr('value');

	// Show the delivery options related to the selected country.
	$('.delivery-option').each(function(){
		var country = $(this).attr('data-country');

		if(country == countrySelected) {
			$(this).addClass('active');
		}
	});

	// When the select option is changed, get the class of the newly selected country
	$('.country-select select').on('change', function(){
		var optionSelected = $(this).children("option:selected").attr('value');

		// Remove the 'active' class from all elements and readd the class to the delivery options related to the new selected country above.
		$('.delivery-option').each(function(){
			var country = $(this).attr('data-country');

			$(this).removeClass('active');
	
			if(country == optionSelected) {
				$(this).addClass('active');
			}
		});
	})
}

sidebarLinks();
searchSuggestionMove();
helpPageSelect();
helpAccordionToggle();
FAQAccordionToggle();
LoyaltyAccordionToggle();
deliveryCountryDropdown();

$(window).on('resize',function() {
	sidebarLinks();
});
function categoryToggle() {
	var categoryTitle = $('.categories-title'),
		categorySidebar = $('.categories-links');
	
	if ($(window).width() <= screenLG) {
		
		categoryTitle.off('click').on('click', function(){
			if ($(this).hasClass('active')) {
				$(this).removeClass('active');
				categorySidebar.slideUp();
			} else {
				$(this).addClass('active');
				categorySidebar.slideDown();
			}
		});
		
	} else {
		categoryTitle.off('click');
		categorySidebar.css('display', '');
	}
}

function returnToBlog() {
	var blogTags = $('.blog-tags li a');

	if ($(blogTags).hasClass('active')) {
		$('.return-to-blog').removeClass('d-none');
	}
}

function blogSearch() {
	$('.blog-search-icon').on('click', function(){
		$('.blog-search-overlay').addClass('active');
		$('html').addClass('no-scroll');
		$('body').addClass('no-scroll');
	});

	$('.blog-overlay-close').on('click', function(){
		$('.blog-search-overlay').removeClass('active');
		$('html').removeClass('no-scroll');
		$('body').removeClass('no-scroll');
	});
}

function clearSearchResults() {
    $('.blog-search-results').html('');
}

function clearSearch() {
    var searchField = $('.blog-search-overlay .input-search'),
        clearInput = $('.blog-search-overlay .search-clear');

    clearInput.on('click', function(){
        searchField.val("").focus();;
        clearSearchResults();
        $('.blog-search-results').removeClass('has-results');
    });
}

/*BG: The predictive search API. for more info visit https://help.shopify.com/en/themes/development/search/predictive-search */
function searchAPI(query) {
    jQuery.getJSON("/search/suggest.json", {
        "q": query,
        "resources": {
            "type": "article",
            "limit": 10,
			"options": {
                "fields": "author,tag,title"
            }
        }
    }).done(function(response) {
        var articleSuggestions = response.resources.results.articles;

        if (articleSuggestions.length > 0) {

            $('.blog-search-results').html('');
            for (var key in articleSuggestions) {
                var article = articleSuggestions[key];
				$.ajax({
					type: 'GET',
					url: '/blogs/blog/' + article.handle +'/?view=search',
					success: function (data) {
						if(!$('.blog-search-results .blog-listing[data-article="'+article['id']+'"]').length) {
							$('.blog-search-results').append(data);
						}
					}
				}); 
            }

        } else {
			$('.blog-search-results').innerHTML('<p>No Results</p>');
        }
    });
}

function searchInput() {
    var searchField = $('.blog-search-overlay .input-search');

    searchField.on('input', function() { 
        var value = $(this).val() 
        if (value.length >= 1) {
            searchAPI(value);
            $('.blog-search-results').addClass('has-results');
        } else {
            $('.blog-search-results').removeClass('has-results');
			$('.blog-search-results').html('');
        }
    });

    clearSearch();
}

function blogCategories() {
	var sidebarTitle = $('.category-dropdown-title'),
			sidebarContent = $('.category-dropdown');
	
	if ($(window).width() <= screenMD) {
		
		sidebarTitle.off('click').on('click', function(){
			if ($(this).hasClass('active')) {
				$(this).removeClass('active');
				$(this).next('.category-dropdown').slideUp();
			} else {
				$(this).addClass('active');
				$(this).next('.category-dropdown').slideDown();
			}
		});
		
	} else {
		sidebarTitle.off('click');
		sidebarContent.css('display', '');
	}
}

//categoryToggle();
returnToBlog();
blogSearch();
searchInput();
blogCategories();

$(window).on('resize',function() {
    blogCategories();
});
function retrieveOrderInfo() {
	var orderItem = $('.account-orders .account-orders-row'),
	allOrderContainer = $('.account-orders .account-orders-row .order-details');

	orderItem.each(function(){
		var orderLink = $(this).find('.orderNumber'),
		orderLinkHref = $(this).find('.orderNumber').attr('href'),
		orderContainer = $(this).find('.order-details');

		$(orderLink).on('click', function(e){
			e.preventDefault();

			if($(orderContainer).is(':empty')) {
				$.ajax({
					method: 'GET',
					url: orderLinkHref,
					dataType: 'html',
					success: function (data) {
						$(allOrderContainer).slideUp();
			            $(allOrderContainer).removeClass('active');
						$(orderContainer).html($(data).find(".order-container"));
						$(orderContainer).slideDown();
						$(orderContainer).addClass("active");
					}
				});
			} else if (!$(orderContainer).hasClass('active')) {
				$(allOrderContainer).slideUp();
			    $(allOrderContainer).removeClass('active');
				$(orderContainer).slideDown();
				$(orderContainer).addClass("active");
			} else {
				$(orderContainer).slideUp();
				$(orderContainer).removeClass('active');
			}
		})
	});
}

retrieveOrderInfo();
  //About US Accordion Functionality.
function aboutUsAccordionToggle() {
	var accordionTitle = $('.about-accordion-header');
	
	accordionTitle.click(function(){
		if ($(this).parent('.about-accordion-item').hasClass('active')) {
			$(this).parent('.about-accordion-item').removeClass('active');
			$(this).next('.about-accordion-content').slideUp();
		} else {
			
			$('.about-accordion-item').removeClass('active');
			$('.about-accordion-content').slideUp();
			
			$(this).parent('.about-accordion-item').addClass('active');
			$(this).next('.about-accordion-content').slideDown();
		}
    })
    
    $('.close-icon').click(function(){
        console.log('hello');
        $(this).parents('.about-accordion-content').slideUp();
        $(this).parents('.about-accordion-item').removeClass('active');
    })
}

aboutUsAccordionToggle()

/*================ Sections ================*/
// Used with sections/header-text-features.liquid
function textFeaturesSlick() {	
	$('.text-features-slick').slick({
        prevArrow: slickPrevArrow,
        nextArrow: slickNextArrow
    });
}

$(document).ready(function() {	
    textFeaturesSlick();
});
//Open and close the mobile Search
function siteSearch() {
	var searchIcon = $('#site-header .header-search-icon'),
		searchBar = $('.search-bar'),
		navigationButton = $('.header-mobile-menu'),
		navigationWrapper = $('#site-navigation');

	searchIcon.click(function(){
		if ($(this).hasClass('active')) {
			$(this).removeClass('active');
			searchBar.removeClass('active');
		} else {
			$(this).addClass('active');
			searchBar.addClass('active');
			searchBar.find('input').focus();
			navigationButton.removeClass('active');
			navigationWrapper.removeClass('active');
			$('.nav-overlay').removeClass('active');
		}
	});
}

//Toggle open and close of mobile navigation
function mobileNavigationMenuToggle() {
	var menuIcon = $('#site-header .header-mobile-menu'),
		menu = $('#site-navigation'),
		overlay = $('.nav-overlay'),
		searchIcon = $('#site-header .header-search-icon'),
		searchBar = $('.search-bar');

	menuIcon.click(function(){
		if ($(this).hasClass('active')) {
			$(this).removeClass('active');
			menu.removeClass('active');
			$('body').css( "overflow", "" );
			$('body').removeClass('hide-gorgias');

		} else {
			$(this).addClass('active');
			menu.addClass('active');
			searchIcon.removeClass('active');
			searchBar.removeClass('active');
			$('body').css( "overflow", "hidden" );
			$('body').addClass('hide-gorgias');
		}
	});

	overlay.click(function() {
		$(this).removeClass('active');
		menu.removeClass('active');
		menuIcon.removeClass('active');
		$('.header-basket a').removeClass('active');
		$('.cart-mini-contents').removeClass('hover');
		$('body').css( "overflow", "" );
		$('body').removeClass('hide-gorgias');
	})
}

//Toggle open and close of the individual links within the navigation.
function mobileNavigation() {
	var parentLink = $('#site-navigation .has-child > a'),
		secondaryLink = $('#site-navigation .has-grandchild > a'),
		tabLinks = $('#site-navigation .mobile-navigation-tabs ul li a'),
		primaryNavigation = $('#site-navigation .top-level'),
		secondaryNavigation = $('#site-navigation .account-navigation-links');
	
	//console.log('screenSM and Lower');
		
	//unbind and bind click action - can cause issues when resizing browser
	parentLink.off('click').on('click', function(e) {
		//print anchor from working.
		e.preventDefault();

		// find offset position of the anchor being clicked
		var thisOffset = $(this).offset();

		// find offset position of ul
		var parentitemOffset = $(this).parent().parent().offset();

		// find top position of anchor element being clicked compared to the ul
		var newOffset = thisOffset.top - parentitemOffset.top;
		
		//add active class to parent and slide down child menus.
		if ($(this).parent('li').hasClass('active')) {
			$(this).parent('li').removeClass('active');
			$(this).parent('li').css('transform', 'translateY(' + newOffset + 'px)');
			$('.top-level > li').removeClass('inactive');
		} else {
			$('.top-level > li').removeClass('active');
			$('.top-level > li').addClass('inactive');
			$(this).parent('li').addClass('active');
			$(this).parent('li').removeClass('inactive');
			$(this).parent('li').css('transform', 'translateY(-' + newOffset + 'px)');
		}
	});

	secondaryLink.off('click').on('click', function(e) {
		//print anchor from working.
		e.preventDefault();

		var link = $(this);
		if ($(this).hasClass('active')) {
			link.removeClass('active');
			$(this).next('ul').slideUp(400, function(){
			});
		} else {
			secondaryLink.removeClass('active').next('ul').slideUp();
			link.addClass('active');
			$(this).next('ul').slideDown(400, function(){
			});
		}
	});

	tabLinks.off('click').on('click', function(e){
		e.preventDefault();

		var hash = $(this).attr('href');
		
		if (hash == "#account") {
			primaryNavigation.addClass('d-none');
			secondaryNavigation.removeClass('d-none');
			$('#site-navigation .mobile-navigation-tabs ul li').removeClass('active');
			$(this).parent().addClass('active');
		} else {
			primaryNavigation.removeClass('d-none');
			secondaryNavigation.addClass('d-none');
			$('#site-navigation .mobile-navigation-tabs ul li').removeClass('active');
			$(this).parent().addClass('active');
		}

	});

	$('#site-navigation').addClass('transition');
}

function desktopNavigation() {
	var mainNavigation = $('#site-navigation'),
		navOverlay = $('.nav-overlay'),
		parentLink = $('#site-navigation .has-child');
	
	if ($(window).width() >= screenLG) {
		//console.log('Screen LG & Greater');
		
		parentLink.on("mouseover", function() {
			$(this).addClass('active');  
			$(this).find('.menu').addClass('active');
			navOverlay.addClass('active');

			//UPDATE
			//BG: for performance reasons, we are now going to load the images within the mega menu when the user hovers on the menu.

			var navigationImages = $(this).find('.sub-menu-image img');
			navigationImages.each(function(){
				var imageURL = $(this).attr('data-image-url')
				if (imageURL) {
					$(this).attr('src',imageURL);
					$(this).removeClass('img-full');
				}
			});
		

		});
		
		parentLink.on("mouseout", function() {
			$(this).removeClass('active');  
			$(this).find('.menu').removeClass('active');
			navOverlay.removeClass('active');
		});

		
		
	} else {
		//console.log('Lower than Screen LG');
		mainNavigation.off("mouseover");
		mainNavigation.off("mouseout");
		parentLink.off("mouseover");
		parentLink.off("mouseout");
	}
}

//BG: Need to move the navigation when on mobile so it doesn't clash with the fixed header.
function moveNavigation() {

	var navigationContainer = $('.site-navigation-container'),
		bodyContainer = $('.body-container'),
		navOverlay = $('.nav-overlay'),
		navigation = $('#site-navigation');


	if ($(window).width() <= screenLG) {
		
		navigation.insertBefore(bodyContainer);
		navOverlay.insertBefore(bodyContainer);

	} else {
		navigationContainer.append(navigation);
		navOverlay.insertAfter('#MainContent');
	}
}

function headroom() {
	// grab an element
	var header = document.querySelector("header");
	var USP = document.querySelector(".header-text-features");
	var filter = document.querySelector(".filter-container");
	var navigation = document.querySelector("#site-navigation");
	// construct an instance of Headroom, passing the element
	var headroomHeader  = new Headroom(header, {
		"offset": 150
	});
	var USPHeader  = new Headroom(USP, {
		"offset": 150
	});
	var headroomFilter  = new Headroom(filter, {
		"offset": 150
	});
	var headroomNav  = new Headroom(navigation, {
		"offset": 150
	});
	// initialise
	headroomHeader.init(); 
	USPHeader.init(); 
	headroomNav.init(); 

	if($(filter).length > 0) {
		headroomFilter.init(); 
	}
}

function countrySelect() {
	var currentCountry = $('.current-country li');

	currentCountry.click(function(){
		$(this).toggleClass('active');
	});
}

function cartHover() {
	$('.header-basket a').off().on("click", function(e){

		if ($(window).width() > screenMD) {
			e.preventDefault();
			if($(this).hasClass('active')) {
				$(this).removeClass('active');
				$('.cart-mini-contents').removeClass('hover');
				$('.nav-overlay').removeClass('active');
				$('html').removeClass('no-scroll');
				$('body').removeClass('no-scroll');
			} else {
				$(this).addClass('active');
				$('.cart-mini-contents').addClass('hover');
				$('.nav-overlay').addClass('active');
				$('html').addClass('no-scroll');
				$('body').addClass('no-scroll');
			}
		}
	});
}

$(document).ready(function() {	
    siteSearch();
    mobileNavigationMenuToggle();
    mobileNavigation();
	//desktopNavigation();
	headroom();
	//moveNavigation();
	countrySelect();
	cartHover();
});

$(window).on('resize',function() {
	mobileNavigation();
	cartHover();
	//desktopNavigation();
	//moveNavigation();
});
function footerLinks() {
	var footerTitle = $('footer .footer-title'),
		footerContent = $('footer .footer-content');

	footerTitle.off('click').on('click', function(){
		if ($(this).hasClass('active')) {
			$(this).removeClass('active');
			$(this).next('.footer-content').slideUp();
		} else {
			$(this).addClass('active');
			$(this).next('.footer-content').slideDown();
		}
	});
}

footerLinks();

$(window).on('resize',function() {
    footerLinks();
});
function featuredImagesSlick() {
    $('.featured-images-slider-slick').slick({
		prevArrow: slickPrevArrow,
		nextArrow: slickNextArrow
	});

	var stHeight = $('.featured-images-slider-slick .slick-track').height();
	$('.featured-images-slider-slick .slick-slide').css('height',stHeight + 'px' );
}

featuredImagesSlick();
function heroSlickInit() {
    $('.hero-slick').each(function(){
        var heroSlick = $(this);
        $(heroSlick).slick({
                prevArrow: slickPrevArrow,
                nextArrow: slickNextArrow
        });
    });
}

heroSlickInit();
function featuredImagesMove() {
    if ($(window).width() > screenMD) {
		$('.small-block-last').appendTo('.small-block-wrapper');
	}

    $(window).on('resize', function() {
        if ($(window).width() > screenMD) {
            $('.small-block-last').appendTo('.small-block-wrapper');
        }
     }); 
}

function featuredImagesScrollSlick() {	
	$slick_slider = $('.featured-image-scroll-slick');
	slicksettings = {
		slidesToShow: 1,
		slidesToScroll: 1,
		infinite: false,
		arrows: true,
		dots: true,
		prevArrow: slickPrevArrow,
		nextArrow: slickNextArrow,
		draggable: true,
	}
	  
	if ($(window).width() < screenMD) {
		$slick_slider.slick(slicksettings); 
	}
  
	// reslick only if it's not slick()
	$(window).on('resize', function() {
	   if ($(window).width() > screenMD) {
	 	if ($slick_slider.hasClass('slick-initialized')) {
	 	  $slick_slider.slick('unslick');
	 	}
	 	return 
	   } else {
	 	  if (!$slick_slider.hasClass('slick-initialized')) {
	 		return $slick_slider.slick(slicksettings);
	 	  }
	   }
	}); 
}

featuredImagesMove();

setTimeout(function(){
	featuredImagesScrollSlick();
	; }, 1000); 

/*================ Snippets ================*/
	/**
	 * Velstar Ajaxify Cart
	 **/
	var config = {

		/* Langauge */
		addToCartBtnText: 		'Add to Basket', //Add to Basket
		addedToCartBtnText: 	'Added to Basket', //Added to Basket
		addingToCartBtnText: 	'Adding', //Adding...
		soldOutBtnText: 		'Sold Out', //Sold Out
		//After adding a product to the cart, how long to wait before it returns to normal?
		returnBtnToNormal: 		4000, // milliseconds

		/* Selectors */
		cartCountSelector: 		'.cart-count',
		cartTotalSelector: 		'.mini-cart-total',
		cartRemoveSelector: 	'.cart-prod-remove',

		/* Icons*/
		successIcon: 			'<svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-check" viewBox="0 0 512 512"><path d="M173.898 439.404l-166.4-166.4c-9.997-9.997-9.997-26.206 0-36.204l36.203-36.204c9.997-9.998 26.207-9.998 36.204 0L192 312.69 432.095 72.596c9.997-9.997 26.207-9.997 36.204 0l36.203 36.204c9.997 9.997 9.997 26.206 0 36.204l-294.4 294.401c-9.998 9.997-26.207 9.997-36.204-.001z"></path></svg>',
		errorIcon: 				'<svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-times" viewBox="0 0 352 512"><path d="M242.72 256l100.07-100.07c12.28-12.28 12.28-32.19 0-44.48l-22.24-22.24c-12.28-12.28-32.19-12.28-44.48 0L176 189.28 75.93 89.21c-12.28-12.28-32.19-12.28-44.48 0L9.21 111.45c-12.28 12.28-12.28 32.19 0 44.48L109.28 256 9.21 356.07c-12.28 12.28-12.28 32.19 0 44.48l22.24 22.24c12.28 12.28 32.2 12.28 44.48 0L176 322.72l100.07 100.07c12.28 12.28 32.2 12.28 44.48 0l22.24-22.24c12.28-12.28 12.28-32.19 0-44.48L242.72 256z"></path></svg>',
		loadingIcon: 			'<svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-sync" viewBox="0 0 512 512"><path d="M500 8h-27.711c-6.739 0-12.157 5.548-11.997 12.286l2.347 98.575C418.212 52.043 342.256 8 256 8 134.813 8 33.933 94.924 12.296 209.824 10.908 217.193 16.604 224 24.103 224h28.576c5.674 0 10.542-3.982 11.737-9.529C83.441 126.128 161.917 60 256 60c79.545 0 147.942 47.282 178.676 115.302l-126.39-3.009c-6.737-.16-12.286 5.257-12.286 11.997V212c0 6.627 5.373 12 12 12h192c6.627 0 12-5.373 12-12V20c0-6.627-5.373-12-12-12zm-12.103 280h-28.576c-5.674 0-10.542 3.982-11.737 9.529C428.559 385.872 350.083 452 256 452c-79.546 0-147.942-47.282-178.676-115.302l126.39 3.009c6.737.16 12.286-5.257 12.286-11.997V300c0-6.627-5.373-12-12-12H12c-6.627 0-12 5.373-12 12v192c0 6.627 5.373 12 12 12h27.711c6.739 0 12.157-5.548 11.997-12.286l-2.347-98.575C93.788 459.957 169.744 504 256 504c121.187 0 222.067-86.924 243.704-201.824 1.388-7.369-4.308-14.176-11.807-14.176z"></path></svg>',


		/* No need to change this elements. */
		addToCartBtnSelector: 	'.btn-add-to-cart.variant-available',
		addToCartFormSelector: 	'form[action="/cart/add"]',
		shopifyAjaxAddURL: 		'/cart/add.js',
		shopifyAjaxChangeURL: 	'/cart/change.js',
		shopifyAjaxCartURL: 	'/cart.js'
	}

//Provide the user Feedback if the Ajax was sucessful or not.
function ajaxFeedback(status, html, $addToCartForm) {
	//$('.ajaxfeedback').remove();
	var feedback = '<p class="ajaxfeedback ' + status + '">' + html + '</p>';

	$addToCartForm.find(config.addToCartBtnSelector).after(feedback);
	$('.ajaxfeedback').slideDown();
}

//BG: Provide the user feedback on the cart template when adjusting quantity / variant.
function ajaxFeedbackCart(status,html,output) {
	$('.ajaxFeedbackCart').remove();
	var feedback = '<span class="ajaxFeedbackCart '+status+'">'+html+'</span>';

	$(output).after(feedback);
}

//Update the button apperance during the various stages. Adding, added, and back to add.
function updateBtnText($button, label, icon) {
	if ($button.children().length) {
		$button.children().each(function () {
			if (icon) {
				if ($.trim($(this).text()) !== '') {
					$(this).html(label + icon);
				}
			} else {
				if ($.trim($(this).text()) !== '') {
					$(this).text(label);
				}
			}
		});
	} else {
		$button.val(label).text(label);
	}
}

//Format the money
function formatMoney(cents, format) {
	if (typeof cents == 'string') {
		cents = cents.replace('.', '');
	}
	var value = '';
	var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
	var formatString = (format || this.money_format);

	function defaultOption(opt, def) {
		return (typeof opt == 'undefined' ? def : opt);
	}

	function formatWithDelimiters(number, precision, thousands, decimal) {
		precision = defaultOption(precision, 2);
		thousands = defaultOption(thousands, ',');
		decimal = defaultOption(decimal, '.');

		if (isNaN(number) || number == null) {
			return 0;
		}

		number = (number / 100.0).toFixed(precision);

		var parts = number.split('.'),
			dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
			cents = parts[1] ? (decimal + parts[1]) : '';

		return dollars + cents;
	}

	switch (formatString.match(placeholderRegex)[1]) {
		case 'amount':
			value = formatWithDelimiters(cents, 2);
			break;
		case 'amount_no_decimals':
			value = formatWithDelimiters(cents, 0);
			break;
		case 'amount_with_comma_separator':
			value = formatWithDelimiters(cents, 2, '.', ',');
			break;
		case 'amount_no_decimals_with_comma_separator':
			value = formatWithDelimiters(cents, 0, '.', ',');
			break;
	}

	return formatString.replace(placeholderRegex, value);
};

//BG: Function to update the Cart Dropdown with the newly added product(s)	
function updateMiniCartContents() {

	//ajax get request to cart.js
	$.ajax({
		type: 'GET',
		url: config.shopifyAjaxCartURL,
		dataType: 'json',
		success: function (data) {

			//Debug
			//console.log(data);

			//Get Cart Total Cost (format it) & Cart Count. 
			var cartTotalCost = slate.Currency.formatMoney(data.total_price, theme.moneyFormat),
				cartCount = data.item_count;

			//Output cart total
			$(config.cartTotalSelector).text(cartTotalCost);
			$(config.cartCountSelector).text(cartCount);
			if (cartCount > 0) {
				$(config.cartCountSelector).removeClass('no-items');
			} else {
				$(config.cartCountSelector).addClass('no-items');
			}


			//remove all items within cart.
			$('.cart-mini-contents .cart-row .cart-item').remove();

			//with the returned data, focus soley on the items. For each item...
			$.each(data.items, function (i, item) {
				//debugging
				//console.log(item);

				var itemTitle = item.product_title;
				var itemPrice = slate.Currency.formatMoney(item.price, theme.moneyFormat);
				var itemQuantity = item.quantity;
				var itemVariantId = item.variant_id;
				var itemImage = item.image;
				var itemUrl = item.url;

				if (item.variant_title) {
                    var itemVariant = item.variant_title;
                } else {
                    var itemVariant = "One Size";
                }

				//add each product back to mini cart preview.
				$('.cart-mini-contents .cart-row').append('<div class="cart-item"><div class="cart-item-left"><div class="cart-prod-img"><a href="' + itemUrl + '"><img src="' + itemImage + '" class="img-fluid"></a></div></div><div class="cart-item-right"><div class="cart-prod-name"><a href="' + itemUrl + '">' + itemTitle + '</a></div><div class="cart-prod-variant"><span>Size : ' + itemVariant + '</span></div><div class="cart-prod-quantity"><span class="label">Quantity : </span><span class="quantity-value">' + itemQuantity + '</span></div><div class="cart-prod-price"><span class="money">Price : ' + itemPrice + '</span></div><a href="/cart" class="btn btn-primary">View Bag</a></div></div>');

			});

			//re-trigger the remove functionality.
			removeCartItemTrigger();
		}
	});
}

//remove product by setting quantity to zero via the data attribute.
function removeItemFromCart(variant_id) {
	//ajax get request to cart.js
	$.ajax({
		type: 'POST',
		url: config.shopifyAjaxChangeURL,
		data: 'quantity=0&id=' + variant_id,
		dataType: 'json',
		success: function (data) {

			//console.log('Remove Item Triggered');
			
			//Update the cart to reflect new contents.
			updateMiniCartContents();

		},
		error: function (XMLHttpRequest) {
			var response = eval('(' + XMLHttpRequest.responseText + ')');
			response = response.description;
			console.log(response);

		}
	});
}

//BG: Function will trigger on the cart page if user changes variant
function addItem(variant_id,quantity,old_variant_id) {
	$.ajax({
		type: 'POST',
		url: config.shopifyAjaxAddURL,
		data: 'quantity='+quantity+'&id=' + variant_id,
		dataType: 'json',
		success: function (data) {
			ajaxFeedbackCart('success','Updated size','.product-title[data-variant-id='+old_variant_id+'] .cart-product-variant-select');
		},
		error: function (XMLHttpRequest) {
			var response = eval('(' + XMLHttpRequest.responseText + ')');
			response = response.description;
		}
	});
}

//BG: function can be triggered by Quantity update, or variant update.
function quantityItemChange(variant_id,value,addProduct,new_variant_id,quantity) {
	//convert string to int
	var variant_id = parseInt(variant_id);

	var freeDeliveryThreshold = parseInt($('.free-delivery-message').attr('data-delivery-threshold')),
		freeDeliveryQual = $('.free-delivery-message').attr('data-delivery-qualified'),
		freeDeliveryFirst = $('.free-delivery-message').attr('data-delivery-message-first'),
		freeDeliveryLast = $('.free-delivery-message').attr('data-delivery-message-last');

	//ajax get request to cart.js
	$.ajax({
		type: 'POST',
		url: config.shopifyAjaxChangeURL,
		data: 'quantity='+value+'&id=' + variant_id,
		dataType: 'json',
		success: function (data) {
			if (addProduct == 'add') {
				addItem(new_variant_id,quantity,variant_id);
			} else {
				$.each(data.items, function(index,item) {
					if (variant_id === item.variant_id) {
						if (item.quantity == value) {
							ajaxFeedbackCart('success','Quantity updated','.basket-item[data-variant-id='+variant_id+'] .product-quantity-select');

						//BG: if the amount has changed, but not to the value the user wanted.
						} else if (item.quantity < value) {
							ajaxFeedbackCart('warning','Quantity Updated to '+item.quantity+'. This is the last remaining amount.','.basket-item[data-variant-id='+variant_id+'] .product-quantity-select');
							$('.basket-item[data-variant-id='+variant_id+'] .product-quantity-select').val(item.quantity);
						}
						return false
					}
				});
			}

			var deliveryCalculation = freeDeliveryThreshold - data.total_price,
				deliveryPrice = slate.Currency.formatMoney(deliveryCalculation, theme.moneyFormat);

			if(data.total_price > freeDeliveryThreshold) {
				$('.free-delivery-message').text(freeDeliveryQual);
			} else {
				$('.free-delivery-message').text(freeDeliveryFirst + deliveryPrice + freeDeliveryLast);
			}

			//Update Total Price
			var cartTotalCost = slate.Currency.formatMoney(data.total_price, theme.moneyFormat);
			$('.basket-total-value span').text(cartTotalCost);
		},
		error: function (XMLHttpRequest) {
			var response = eval('(' + XMLHttpRequest.responseText + ')');
			response = response.description;
		}
	});
}




//Define the remove cart item selector, use the .off & .on feature to ensure it works correctly after new contents added to mini cart.
function removeCartItemTrigger() {
	//Remove Item from Cart
	$(config.cartRemoveSelector + ' span').off().on("click", function () {
		var varientID = $(this).attr('data-variant-id');

		$(this).parents('.cart-item').slideUp();
		
		//Pass over to removeItemFromCart Function.
		removeItemFromCart(varientID);

	});
}

function addToCart(form) {
		$('.ajaxfeedback').remove();
		//e.preventDefault();
		var $addToCartForm = form;
		var $addToCartBtn = $addToCartForm.find(config.addToCartBtnSelector+':first-of-type');

		//Adding button stage
		updateBtnText($addToCartBtn, config.addingToCartBtnText, config.loadingIcon);
		$addToCartBtn.addClass('btn-adding').prop('disabled', true);

		// Add to cart.
		$.ajax({
			url: config.shopifyAjaxAddURL,
			dataType: 'json',
			type: 'post',
			data: $addToCartForm.serialize(),
			success: function (itemData) {

				//Added button stage
				updateBtnText($addToCartBtn, config.addedToCartBtnText, config.successIcon);
				$addToCartBtn.removeClass('btn-adding').addClass('btn-added');

				//Once added, reset button back to add.
				window.setTimeout(function () {
					$addToCartBtn.prop('disabled', false).removeClass('btn-added');
					updateBtnText($addToCartBtn, config.addToCartBtnText);
				}, config.returnBtnToNormal);

				updateMiniCartContents();

				window.setTimeout(function () {
					//$('.header-basket .cart-icon').addClass('swing animated');
					$('.cart-mini-contents').addClass('active');
					$('.nav-overlay').addClass('active');
				}, 1000);

				window.setTimeout(function () {
					$('.cart-mini-contents').removeClass('active');
					$('.nav-overlay').removeClass('active');
					//$('.header-basket .cart-icon').removeClass('swing animated');
				}, 6000);
				
			},
			error: function (XMLHttpRequest) {
				var response = eval('(' + XMLHttpRequest.responseText + ')');
				response = response.description;
				if (response.slice(0, 4) === 'All ') {
					ajaxFeedback('error', response.replace('All 1 ', 'All '), $addToCartForm);
					$addToCartBtn.prop('disabled', false);
					updateBtnText($addToCartBtn, config.soldOutBtnText);
					$addToCartBtn.prop('disabled', true).removeClass('btn-adding').removeClass('btn-added');
				} else {
					ajaxFeedback('error', '<i class="fa fa-warning"></i> ' + response, $addToCartForm);
					$addToCartBtn.prop('disabled', false).removeClass('disabled');
					updateBtnText($addToCartBtn, config.addToCartBtnText);
				}

			}

		});
		return false;
}



//BG: allows the user to update the quantity and/or variant on the cart page.
function cartItemQuantityVariant() {
	var cartItem = $('.basket-item');

	cartItem.each(function(){
		var variantSelect = $(this).find('product-variant-select'),
			variantSelectValueOriginal = '',
			quantitySelect = $(this).find('.product-quantity-select'),
			quantitySelectId = quantitySelect.attr('data-variant-id'),
			quantitySelectValue = quantitySelect.val();

		variantSelect.on('focus', function(){
			variantSelectValueOriginal = $(this).val();
		});

		variantSelect.on('change', function(){
			var variantSelectValue = $(this).val();
			quantitySelectId = quantitySelect.attr('data-variant-id',variantSelectValue);
			quantityItemChange(variantSelectValueOriginal,0,'add',variantSelectValue,quantitySelectValue);

		});

		quantitySelect.on('change',function(){
			quantitySelectValue = $(this).val();
			quantitySelectId = quantitySelect.attr('data-variant-id');
			quantityItemChange(quantitySelectId,quantitySelectValue);
		})	
	});
}

$(document).ready(function() {

	if ($('body').hasClass('template-cart')) {
		//cartItemQuantity();
		//cartItemVariantSize();
		cartItemQuantityVariant();
	}
	
	removeCartItemTrigger();
	
	$(config.addToCartFormSelector).submit(function (e) {
		e.preventDefault();
		addToCart($(this));
	});
});
if($('body').hasClass('template-product')) {
    var productObjectId = $('.product-colours-object').attr('data-product-id');
    var productColourTag = $('.product-colours-object').attr('data-current-product-group');
    var prouductURL = $('.product-colours-object').attr('data-url');

    getProductRangeColoursProduct(productObjectId, productColourTag);
    function getProductRangeColoursProduct(productID, tag) {
    $.ajax({
        method: 'GET',
        url: '/collections/all/' + tag + '?view=json',
        success: function (data) {
            if(data) {
                try {
                    var json = JSON.parse(data);
                } catch(e) {
                    var json = null; // meh
                }
            }
            if (json) {
                var itemVariantHtml = '<div><div class="swatch swatch-size clearfix product-section product-related-colours"><div class="colour-container">';
                for (var key in json.products) {
                    if (prouductURL == json.products[key]['handle']) {
                        itemVariantHtml += '<div class="product product-colours colourswatch-container current">';
                        itemVariantHtml += '<a href="' + json.products[key]['url'] + '"><div title="' + json.products[key]['title'] + '" class="product current colourswatch ' + json.products[key]['colour'].toLowerCase() + '"></div></a>';
                        itemVariantHtml += '</div>';
                    } else {
                        itemVariantHtml += '<div class="product product-colours colourswatch-container">';
                        itemVariantHtml += '<a href="' + json.products[key]['url'] + '"><div title="' + json.products[key]['title'] + '" class="product colourswatch ' + json.products[key]['colour'].toLowerCase() + '"></div></a>';
                        itemVariantHtml += '</div>';
                    }
                }
                itemVariantHtml += '</div></div>';
                $('.selected-colour').after(itemVariantHtml);
            }
        }
    });
    }
}


function cookieBanner() {

    var cookieBar = $('.cookie-bar'),
        cookieValue = getCookie('cookie-bar'),
        cookieBtn = $('.cookie-bar .btn');

    if (!cookieValue) {
        cookieBar.removeClass('d-none');
    }

    cookieBtn.on('click', function(){
        cookieBar.addClass('d-none');
        setCookie('cookie-bar','accepted',60);
    });

}

cookieBanner(); 
//BG: Init slickSlider for Recently Viewed and Related Products.
function recentSlickSlider(target) {
    $(target).slick({
        infinite: false,
        slidesToShow: 5,
        slidesToScroll: 5,
        arrows:true,
        dots: false,
        prevArrow: slickPrevArrow,
        nextArrow: slickNextArrow,
        responsive: [
            {
                breakpoint: 992,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 3
                }
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2
                }
            }
        ]
    });
}

//BG: Grab the recently viewed products array, and loop through the products and output them.
function retrieveRecentlyViewedProducts(array,outputLocation,maxProducts) {

    //if the array is greater than max allowed products, delete the last product from the array.
    if (array.length > maxProducts) {
        array.shift();
    }

    //if there are products to display, remove the hidden class.
    if (array.length > 0) {
        $(outputLocation).removeClass('d-none');
    }

    if (array.length === undefined) {
        localStorage.removeItem("recentProducts");
    }

    // loop for the array, and output the products.
    $.each(array,function(i, product) {

        //ensure the product isn't undefined.
        if (product != "undefined.js" && product != ".js") {
            //make a json request based on the product handle.
            var ajax = $.getJSON('/products/' + product, function(data) {
                //pass the data over to the below function
                outputProduct(data,outputLocation);
            }).fail(function() { 
                //BG: This should rarely happen, but if the product is no longer available, we get a json error, so want to remove the product from the array. 
                console.log('product not found, but it will be removed from array on next page load')
                var arrayFix = array.indexOf(product);
                if (arrayFix !== -1) {
                     array.splice(arrayFix,1);
                }
                //BG: Update localStorage
                localStorage.setItem("recentProducts", JSON.stringify(arrayFix));
            });
        }

        //Check to see if it's the last item in the Array, if it is...
        var increment = i + 1;

        if (array.length == increment) {
            //persistentCheck('.featured-products.product-recently-viewed .featured-product',1,recentSlickSlider,'.featured-products.product-recently-viewed .featured-products-slick',5000);
        }
    });

    if ($(window).width() < screenMD) {
		if (array.length > 2) {
            setTimeout(function() {
                persistentCheck('.featured-products.product-recently-viewed .featured-product',2,recentSlickSlider,'.featured-products.product-recently-viewed .featured-products-slick',5000);
            }, 1000);
        }
	} else {
        if (array.length > 4) {
            setTimeout(function() {
                persistentCheck('.featured-products.product-recently-viewed .featured-product',4,recentSlickSlider,'.featured-products.product-recently-viewed .featured-products-slick',5000);
            }, 1000);
        }
    }
}

//BG: Add current product to the recently viewed array
function addNewProduct(array,productHandle,maxProducts) {

  //BG: if array is greater than the maxProducts, then delete the first item in the array
  if (array.length > maxProducts) {
    array.shift();
  }

  //BG: only add the product to the array, if it doesn't already exist
  if(array.indexOf(productHandle) == -1 && productHandle != "undefined.js") {
      array.push(productHandle);
  }
  //BG: Update localStorage
  localStorage.setItem("recentProducts", JSON.stringify(array));

}

//BG: Using localStorage, we create an array based on the products the user has been viewing. When they visit a product page, it stores the product handle. 
function recentlyViewedProducts() {
    //Retrieve localstorage for recentproducts(if it exists)
    var savedRecentProducts = JSON.parse(localStorage.getItem("recentProducts")),
        outputLocation = ".product-recently-viewed",
        newProduct = $(outputLocation).attr('data-product-handle');
        newProduct = newProduct + ".js",
        maxProducts = 10;

    //if localstorage exists, retrieve the list and output it
    if (savedRecentProducts) {
        retrieveRecentlyViewedProducts(savedRecentProducts,outputLocation,maxProducts);
        addNewProduct(savedRecentProducts,newProduct,maxProducts);
    } else {
        //First time user has visited a product page, so let's create the new local storage.
        //console.log('doesn\'t exist, let\'s make a new array');
        var recentProducts = [];
        addNewProduct(recentProducts,newProduct,maxProducts);
    }
}

recentlyViewedProducts();
function setCookie(cname, cvalue, exdays) {
    var d = new Date();
    d.setTime(d.getTime() + (exdays*24*60*60*1000));
    var expires = "expires="+ d.toUTCString();
    document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/;domain=aabcollection.com";
}

function getCookie(cname) { 
    var name = cname + "=";
    var decodedCookie = decodeURIComponent(document.cookie);
    var ca = decodedCookie.split(';');
    for(var i = 0; i <ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) == ' ') {
        c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length); 
      }
    }
    return ""; 
}


function geoLocation() {

    var storePreference = localStorage.getItem('storePreferenceValue'),
        stayOnStorePreference = getCookie("stayOnStore"),
        cookieStorePreference = getCookie("cookieStorePreferenceNew"),
        storeAddress = $('.store-redirect').attr('data-store-address'),
        redirectPopup = $('.redirect-popup'),
        redirectOverlay = $('.redirect-overlay'),
        redirectTargetCountry = $('.redirect-content .target-country'),
        redirectButtonLink = $('.redirect-content .btn-redirect'),
        URLPath = window.location.pathname;

    // If customer has not clicked 'Stay on Store' or changed site in site select.
    if (stayOnStorePreference == "") {
        //If store preference is not set....
        if (cookieStorePreference == "") {
            //console.log('preference not set');

            $.ajax({
                url: '//api.ipstack.com/check?access_key=2a5a6352a5a836fc05f69c8f88a0c068',
                dataType: 'json',
                success: function (json) {

                    //If customer is from US
                    if (json.country_code == "US") {
                        //Check to see if store is also US
                        if (storeAddress.indexOf('us') >= 0) {
                            //If customer and store are both US, do nothing. They are were they are supposed to be.
                            //set user store preference
                            setCookie("cookieStorePreferenceNew", "US", 365)
                        } else {
                            //show redirect popup - with option to redirect to US.
                            $(redirectTargetCountry).html('US');
                            $(redirectButtonLink).attr('href', 'https://us.aabcollection.com' + URLPath);
                            $(redirectPopup).addClass('active');
                            $(redirectOverlay).addClass('active');
                        }
                    } else if (json.country_code == "GB") {
                        //If customer is from UK
                        //Check to see if store is also UK
                        if (storeAddress === 'aabcollection.com') {
                            //If customer and store are both UK, do nothing. They are were they are supposed to be.
                            //set user store preference
                            setCookie("cookieStorePreferenceNew", "UK", 365)
                        } else {
                            //show redirect popup - with option to redirect to UK.
                            $(redirectTargetCountry).html('UK');
                            $(redirectButtonLink).attr('href', 'https://aabcollection.com' + URLPath);
                            $(redirectPopup).addClass('active');
                            $(redirectOverlay).addClass('active');  
                        }
                    } else if (json.country_code == "FR") {
                        //If customer is from France
                        //Check to see if store is also France
                        if (storeAddress.indexOf('fr') >= 0) {
                            //If customer and store are both France, do nothing. They are were they are supposed to be.
                            //set user store preference
                            setCookie("cookieStorePreferenceNew", "FR", 365)
                        } else {
                            //show redirect popup - with option to redirect to FR.
                            $(redirectTargetCountry).html('FR');
                            $(redirectButtonLink).attr('href', 'https://fr.aabcollection.com' + URLPath);
                            $(redirectPopup).addClass('active');
                            $(redirectOverlay).addClass('active');  
                        }
                    } else if (json.country_code == "DE") {
                        //If customer is from DE
                        //Check to see if store is also DE
                        if (storeAddress.indexOf('de') >= 0) {
                            //If customer and store are both DE, do nothing. They are were they are supposed to be.
                            //set user store preference
                            setCookie("cookieStorePreferenceNew", "DE", 365)
                        } else {
                            //show redirect popup - with option to redirect to DE.
                            $(redirectTargetCountry).html('DE');
                            $(redirectButtonLink).attr('href', 'https://de.aabcollection.com' + URLPath);
                            $(redirectPopup).addClass('active');
                            $(redirectOverlay).addClass('active');  
                        }
                    } 
                 	 else if (json.country_code == "CA") {
                        //If customer is from CA
                        //Check to see if store is also Ca
                        if (storeAddress.indexOf('ca') >= 0) {
                            //If customer and store are both CA, do nothing. They are were they are supposed to be.
                            //set user store preference
                            setCookie("cookieStorePreferenceNew", "CA", 365)
                        } else {
                            //show redirect popup - with option to redirect to DE.
                            $(redirectTargetCountry).html('CA');
                            $(redirectButtonLink).attr('href', 'https://ca.aabcollection.com' + URLPath);
                            $(redirectPopup).addClass('active');
                            $(redirectOverlay).addClass('active');  
                        }
                    }else if (json.continent_code == "EU" && json.country_code != "GB" && json.country_code != "FR" && json.country_code != "DE") {
                        //If customer is from Europe but not UK, France + Germany.
                        //Check to see if store is also EU
                        if (storeAddress.indexOf('eu') >= 0) {
                            //set user store preference
                            setCookie("cookieStorePreferenceNew", "EU", 365)
                        } else {
                            //show redirect popup - with option to redirect to EU.
                            $(redirectTargetCountry).html('EU');
                            $(redirectButtonLink).attr('href', 'https://eu.aabcollection.com' + URLPath);
                            $(redirectPopup).addClass('active');
                            $(redirectOverlay).addClass('active');  
                        }
                    } else {
                        // IF Customer is not from any of the above
                        //Check to see if store is INT
                        if (storeAddress.indexOf('int') >= 0) {
                            //set user store preference
                            setCookie("cookieStorePreferenceNew", "INT", 365) 
                        } else {                      
                            //show redirect popup - with option to redirect to US.
                            $(redirectTargetCountry).html('INT');
                            $(redirectButtonLink).attr('href', 'https://int.aabcollection.com' + URLPath);
                            $(redirectPopup).addClass('active');
                            $(redirectOverlay).addClass('active');
                        }
                    }
                }
            });

        //IF store preference is set.   
        } else if (cookieStorePreference == "US") {
            //console.log('preference:' +cookieStorePreference);

            //IF store preference is US. 
            if (storeAddress.indexOf('us') >= 0) {
                // and customer is on US store. Do nothing. 
            } else {
                window.top.location.href = "https://us.aabcollection.com" + URLPath; 
            }
        } else if (cookieStorePreference == "UK") {
            //console.log('preference:' +cookieStorePreference);

            //IF store preference is UK. 
            if (storeAddress === 'aabcollection.com') {
                // and customer is on UK store. Do nothing. 
            } else {
                window.top.location.href = "https://aabcollection.com" + URLPath; 
            }
        } 
      	else if (cookieStorePreference == "CA") {
            //console.log('preference:' +cookieStorePreference);

            //IF store preference is FR. 
            if (storeAddress.indexOf('ca') >= 0) {
                // and customer is on FR store. Do nothing. 
            } else {
                window.top.location.href = "https://ca.aabcollection.com" + URLPath; 
            }
        }
      	else if (cookieStorePreference == "FR") {
            //console.log('preference:' +cookieStorePreference);

            //IF store preference is FR. 
            if (storeAddress.indexOf('fr') >= 0) {
                // and customer is on FR store. Do nothing. 
            } else {
                window.top.location.href = "https://fr.aabcollection.com" + URLPath; 
            }
        } else if (cookieStorePreference == "DE") {
            //console.log('preference:' +cookieStorePreference);

            //IF store preference is DE. 
            if (storeAddress.indexOf('de') >= 0) {
                // and customer is on DE store. Do nothing. 
            } else {
                window.top.location.href = "https://de.aabcollection.com" + URLPath; 
            }
        } else if (cookieStorePreference == "EU") {
            //console.log('preference:' +cookieStorePreference);

            //IF store preference is EU. 
            if (storeAddress.indexOf('eu') >= 0) {
                // and customer is on EU store. Do nothing. 
            } else {
                window.top.location.href = "https://eu.aabcollection.com" + URLPath;
            }
        } else if (cookieStorePreference == "INT") {
            //console.log('preference:' +cookieStorePreference);

            //IF store preference is INT. 
            if (storeAddress.indexOf('int') >= 0) {
                // and customer is on INT store. Do nothing. 
            } else {
                window.top.location.href = "https://int.aabcollection.com" + URLPath; 
            }
        }
      // If customer has set a preference with 'Stay on Store' or changed site in site select and they land on another store - ask if they want to be redirected to their prefered store.
    } else if (stayOnStorePreference == "US") {
        //IF store preference is US. 
        if (storeAddress.indexOf('us') >= 0) {
            // and customer is on US store. Do nothing. 
        } else {
            window.top.location.href = "https://us.aabcollection.com" + URLPath;
        }
    } else if (stayOnStorePreference == "UK") {
        //IF store preference is UK. 
        if (storeAddress === 'aabcollection.com') {
            // and customer is on UK store. Do nothing. 
        } else {
            window.top.location.href = "https://aabcollection.com" + URLPath;
        }
    } else if (stayOnStorePreference == "FR") {
        //IF store preference is FR. 
        if (storeAddress.indexOf('fr') >= 0) {
            // and customer is on FR store. Do nothing. 
        } else {
            window.top.location.href = "https://fr.aabcollection.com" + URLPath;
        }
    } else if (stayOnStorePreference == "DE") {
        //IF store preference is DE. 
        if (storeAddress.indexOf('de') >= 0) {
            // and customer is on DE store. Do nothing. 
        } else {
            window.top.location.href = "https://de.aabcollection.com" + URLPath;
        }
    } else if (stayOnStorePreference == "EU") {
        //IF store preference is EU. 
        if (storeAddress.indexOf('eu') >= 0) {
            // and customer is on EU store. Do nothing. 
        } else {
            window.top.location.href = "https://eu.aabcollection.com" + URLPath;
        }
    } else if (stayOnStorePreference == "CA") {
        //IF store preference is CA. 
        if (storeAddress.indexOf('ca') >= 0) {
            // and customer is on CA store. Do nothing. 
        } else {
            window.top.location.href = "https://ca.aabcollection.com" + URLPath;
        }
    } else if (stayOnStorePreference == "INT") {
        //IF store preference is INT. 
        if (storeAddress.indexOf('int') >= 0) {
            // and customer is on INT store. Do nothing. 
        } else {
            window.top.location.href = "https://int.aabcollection.com" + URLPath;
        }
    }
}

function countrySelectChange() {
    var link = $('.country-select a');
    link.on("click", function(e){
        e.preventDefault(); 

        var value = $(this).text(),
            drophref = $(this).attr('href'); 

        if (value == "US") {
            //localStorage.setItem('storePreferenceValue', 'US');
            setCookie("cookieStorePreferenceNew", "US", 365)
            setCookie("stayOnStore", "US", 365)
            //console.log('preference set US');
            window.top.location.href = drophref; 
        } else if (value == "UK") {
            //localStorage.setItem('storePreferenceValue', 'UK');
            setCookie("cookieStorePreferenceNew", "UK", 365)
            setCookie("stayOnStore", "UK", 365)
            //console.log('preference set UK');
            window.top.location.href = drophref; 
        } else if (value == "FR") {
            //localStorage.setItem('storePreferenceValue', 'FR');
            setCookie("cookieStorePreferenceNew", "FR", 365)
            setCookie("stayOnStore", "FR", 365)
            //console.log('preference set FR');
            window.top.location.href = drophref; 
        } else if (value == "CA") {
            //localStorage.setItem('storePreferenceValue', 'FR');
            setCookie("cookieStorePreferenceNew", "CA", 365)
            setCookie("stayOnStore", "CA", 365)
            //console.log('preference set FR');
            window.top.location.href = drophref; 
        } else if (value == "DE") {
            //localStorage.setItem('storePreferenceValue', 'DE');
            setCookie("cookieStorePreferenceNew", "DE", 365)
            setCookie("stayOnStore", "DE", 365)
            //console.log('preference set DE');
            window.top.location.href = drophref; 
        } else if (value == "EU") {
            //localStorage.setItem('storePreferenceValue', 'EU');
            setCookie("cookieStorePreferenceNew", "EU", 365)
            setCookie("stayOnStore", "EU", 365)
            //console.log('preference set EU');
            window.top.location.href = drophref; 
        } else if (value == "INT") {
            //localStorage.setItem('storePreferenceValue', 'INT');
            setCookie("cookieStorePreferenceNew", "INT", 365)
            setCookie("stayOnStore", "INT", 365)
            //console.log('preference set INT');
            window.top.location.href = drophref; 
        }
    })
}

function redirectClose() {
    $('.redirect-close').off('click').on('click', function(){

        var storeAddress = $('.store-redirect').attr('data-store-address');

        $('.redirect-popup').removeClass('active');
        $('.redirect-overlay').removeClass('active');

        if (storeAddress.indexOf('us') >= 0) {
            setCookie("cookieStorePreferenceNew", "US", 365)
            setCookie("stayOnStore", "US", 365)
        } else if (storeAddress === 'aabcollection.com') {
            setCookie("cookieStorePreferenceNew", "UK", 365)
            setCookie("stayOnStore", "UK", 365)
        } else if (storeAddress.indexOf('fr') >= 0) {
            setCookie("cookieStorePreferenceNew", "FR", 365)
            setCookie("stayOnStore", "FR", 365)
        } else if (storeAddress.indexOf('de') >= 0) {
            setCookie("cookieStorePreferenceNew", "DE", 365)
            setCookie("stayOnStore", "DE", 365)
        } else if (storeAddress.indexOf('eu') >= 0) {
            setCookie("cookieStorePreferenceNew", "EU", 365)
            setCookie("stayOnStore", "EU", 365)
        } else if (storeAddress.indexOf('int') >= 0) {
            setCookie("cookieStorePreferenceNew", "INT", 365)
            setCookie("stayOnStore", "INT", 365)
        } else if (storeAddress.indexOf('CA') >= 0) {
            setCookie("cookieStorePreferenceNew", "ca", 365)
            setCookie("stayOnStore", "ca", 365)
        }

    });
}

function redirectCheck() {
   var storeRedirect = $('.store-redirect'); 

   if (storeRedirect.length) {
       geoLocation();
       countrySelectChange();
       redirectClose();
   }
}


function padNum(number) {
    return (number < 10 ? '0' : '') + number
}  

//BG: Todays date defined by the timezone set within Shopify.
var todayDate = parseInt($('#hero-countdown').attr('data-today-date')),
    todayMonth = parseInt($('#hero-countdown').attr('data-today-month')),
    todayYear = parseInt($('#hero-countdown').attr('data-today-year')),
    todayFullDate = padNum(todayYear) + '-' + padNum(todayMonth) + '-' + padNum(todayDate);

//BG: check to see if date countdown is present, if so let's run the countdown.
if ($('#hero-countdown .usp-item.date-countdown').length) {

    var targetHour = $('#hero-countdown .usp-item.date-countdown .dateCountdown').attr('data-hours'),
        targetMinute = $('#hero-countdown .usp-item.date-countdown .dateCountdown').attr('data-minutes'),
        combinedTime = " " + padNum(targetHour) + ":" + padNum(targetMinute),
        targetMonthDate = parseInt($('#hero-countdown .usp-item.date-countdown .dateCountdown').attr('data-month-date')),
        targetMonth = parseInt($('#hero-countdown .usp-item.date-countdown .dateCountdown').attr('data-month')),
        targetYear = parseInt($('#hero-countdown .usp-item.date-countdown .dateCountdown').attr('data-year')),
        combinedDate = targetYear + "-" + padNum(targetMonth) + "-" + padNum(targetMonthDate),
        finishedText = $('#hero-countdown .usp-item.date-countdown .dateCountdown').attr('data-aftercountdown'),
        targetTimezone = $('#hero-countdown .usp-item.date-countdown .dateCountdown').attr('data-timezone');
    
    
        /* BG: Honestly, I don't know know why I can't just drop in the timezone as a param, but for some unknown reason, it wasn't accepting it correctly and throwing the time out.
    
        What I tried:
        - var dailyTimer = moment.tz(todayFullDate + combinedTime, + targetTimezone);
        - var dailyTimer = moment.tz(todayFullDate + combinedTime, + '"' + targetTimezone + '"');
        */

        //console.log(targetTimezone);
        //console.log(combinedDate);
        //console.log(combinedTime);
    
        if (targetTimezone == "us") {
            var dailyTimer = moment.tz(combinedDate + combinedTime, "America/Los_Angeles");
        } else if (targetTimezone == "au") {
            var dailyTimer = moment.tz(combinedDate + combinedTime, "Australia/Brisbane");
        } else if (targetTimezone == "euro") {
            var dailyTimer = moment.tz(combinedDate + combinedTime, "UTC");
        } else {
            var dailyTimer = moment.tz(combinedDate + combinedTime, "Europe/London");
        }
    
    $('.dateCountdown').countdown(dailyTimer.toDate(), function(event){
        $(this).on('update.countdown', function(event) {
            $(this).html(event.strftime('<div>%D</div><div>%H</div><div>%M</div><div>%S</div>'));
        }).on('finish.countdown', function(event) {
            $(this).parent().text(finishedText);
        });
    })
    
    }

$(document).ready(function() {
  var sections = new slate.Sections();
  sections.register('product', theme.Product);

  // Common a11y fixes
  slate.a11y.pageLinkFocus($(window.location.hash));

  $('.in-page-link').on('click', function(evt) {
    slate.a11y.pageLinkFocus($(evt.currentTarget.hash));
  });

  // Target tables to make them scrollable
  var tableSelectors = '.rte table';

  slate.rte.wrapTable({
    $tables: $(tableSelectors),
    tableWrapperClass: 'rte__table-wrapper',
  });

  // Target iframes to make them responsive
  var iframeSelectors =
    '.rte iframe[src*="youtube.com/embed"],' +
    '.rte iframe[src*="player.vimeo"]';

  slate.rte.wrapIframe({
    $iframes: $(iframeSelectors),
    iframeWrapperClass: 'rte__video-wrapper'
  });

  // Apply a specific class to the html element for browser support of cookies.
  if (slate.cart.cookiesEnabled()) {
    document.documentElement.className = document.documentElement.className.replace('supports-no-cookies', 'supports-cookies');
  }
});

/* ==========================================================================
#Custom Velstar
========================================================================== */


//product page swatch change
$('.swatch :radio').change(function() {
	var optionIndex = $(this).closest('.swatch').attr('data-option-index');
	var optionValue = $(this).val();
	$(this).closest('form').find('.single-option-selector').eq(optionIndex).val(optionValue).trigger('change');
});

window.Plus = window.Plus || {};

Plus.HeroVideo = function() {

  const breakpoints = {
    small: 576,
    large: 992
  }

  const selectors = {
    heroSections: 'hero-slick',
    container: '.plus-hero-video',
    playButton: '.plus-hero-video__control--playbutton',
    videoWrapper: '.plus-hero-video__wrapper',
    videoImageContainer: '.plus-hero-video__image',
    slideContent: '.plus-hero-video__content'
  }

  const isMobile = function() {
    return window.innerWidth < breakpoints.small;
  }

  const isWidescreen = function() {
    return window.innerWidth >= breakpoints.large;
  }

  const resizeHandler = function(slideContent) {
    window.addEventListener('resize', function() {
      if (isWidescreen()) {
        slideContent.style.opacity = "1";
        slideContent.style.visibility = "visible";
      } else {
        hideContent(slideContent);
      }
    })
  }

  const hideContent = function(slideContent) {
    if (('hideDuringPlay' in slideContent.dataset) && (! isWidescreen())) {
      slideContent.style.opacity = "0";
      slideContent.style.visibility = "hidden";
    }
  }

  const mobileSource = function(videoPlayer) {
    if (isMobile()) {
      if ('mobileVideo' in videoPlayer.dataset) {
        let mobileUrl = videoPlayer.dataset.mobileVideo;
        let source = videoPlayer.getElementsByTagName('source');
        source[0].setAttribute('src', mobileUrl);
        videoPlayer.load();
      }
    }
  }

  const initHero = function(section) {
    let playButton = section.querySelector(selectors.playButton);
    let container = section.querySelector(selectors.container);
    let videoWrapper = section.querySelector(selectors.videoWrapper);
    let videoPlayer = videoWrapper.getElementsByTagName('video');
    let videoImageContainer = videoWrapper.querySelector(selectors.videoImageContainer);
    let slideContent = section.querySelector(selectors.slideContent);

    playButton.addEventListener('click', () => {
      videoImageContainer.style.opacity = "0";
      videoImageContainer.style.zIndex = "1";
      playButton.style.opacity = "0.0";
      playButton.style.visibility = "hidden";
      hideContent(slideContent);
      if (typeof(videoPlayer) != 'undefined' && videoPlayer != null) {
        videoPlayer[0].setAttribute("controls","controls");
        videoPlayer[0].muted = !videoPlayer[0].muted;
        videoPlayer[0].play();
      }
    });

    if ((container.classList.contains('background-video')) && (! isMobile())) {
      hideContent(slideContent);
      playButton.style.opacity = "0.0";
      playButton.style.visibility = "hidden";
      if (typeof(videoPlayer) != 'undefined' && videoPlayer != null) {
        videoPlayer[0].play();
      }
    }

    if (typeof(videoPlayer) != 'undefined' && videoPlayer != null) {
      mobileSource(videoPlayer[0]);
    }
    resizeHandler(slideContent);
  }

  const init = function() {
    let heroSections = document.getElementsByClassName(selectors.heroSections);
    Array.from(heroSections).forEach((section) => {
      initHero(section);
    });
  }

  return init;
}

window.addEventListener('DOMContentLoaded', Plus.HeroVideo());